/* tslint:disable */
/* eslint-disable */
/**
 * Dazzle API
 * Dazzle photo intelligent AI agent API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
export const ActionContentTypeEnum = {
    Action: 'action'
};
export const ActionExecutionMode = {
    Present: 'present',
    Execute: 'execute'
};
/**
 * Barcode symbologies supported for wallet passes.
 */
export const BarcodeType = {
    Qr: 'QR',
    Code128: 'CODE128',
    Pdf417: 'PDF417',
    Aztec: 'AZTEC'
};
export const CalendarActionActionTypeEnum = {
    Calendar: 'calendar'
};
export const CalendarContentTypeEnum = {
    Calendar: 'CALENDAR'
};
/**
 * Camera roll access permission
 */
export const CameraRollPermission = {
    All: 'ALL',
    SelectedPhotos: 'SELECTED_PHOTOS',
    None: 'NONE'
};
export const ChatActionActionTypeEnum = {
    Chat: 'chat'
};
export const ContactActionActionTypeEnum = {
    Contact: 'contact'
};
export const ContactContentTypeEnum = {
    Contact: 'CONTACT'
};
export const CoordinateContentTypeEnum = {
    Coordinate: 'COORDINATE'
};
/**
 * A user\'s tier for accessing the developer/platform API.  NULL in the DB means \"not a developer\". Only members of this enum are valid non-null values. Future tiers (PRO, ENTERPRISE, COMPED, ...) can be added here without a schema change.
 */
export const DeveloperTier = {
    Beta: 'BETA'
};
export const DismissActionActionTypeEnum = {
    Dismiss: 'dismiss'
};
/**
 * HTTP error types.
 */
export const ErrorType = {
    NUMBER_400: 400,
    NUMBER_401: 401,
    NUMBER_403: 403,
    NUMBER_404: 404,
    NUMBER_500: 500
};
/**
 * Eval run status.
 */
export const EvalRunStatus = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
};
/**
 * Eval suite types.
 */
export const EvalSuite = {
    Intent: 'INTENT',
    Aesthetic: 'AESTHETIC',
    OrderIntent: 'ORDER_INTENT',
    OrderAgent: 'ORDER_AGENT',
    Ideas: 'IDEAS',
    IdeasImage: 'IDEAS_IMAGE'
};
export const FaceTaggingActionActionTypeEnum = {
    FaceTagging: 'face_tagging'
};
export const FaceTaggingContentTypeEnum = {
    FaceTagging: 'FACE_TAGGING'
};
export const FeatureFlagAction = {
    Enable: 'ENABLE',
    Disable: 'DISABLE',
    AddToWhitelist: 'ADD_TO_WHITELIST',
    RemoveFromWhitelist: 'REMOVE_FROM_WHITELIST',
    AddToBlacklist: 'ADD_TO_BLACKLIST',
    RemoveFromBlacklist: 'REMOVE_FROM_BLACKLIST'
};
/**
 * Feature flag identifiers.  Example:     NEW_FEATURE = \"NEW_FEATURE\"
 */
export const FeatureFlagId = {
    AuditEventsWhitelist: 'AUDIT_EVENTS_WHITELIST',
    AuthPiiWhitelist: 'AUTH_PII_WHITELIST',
    EnableLlmTracing: 'ENABLE_LLM_TRACING',
    EnableParallelChatContextBuild: 'ENABLE_PARALLEL_CHAT_CONTEXT_BUILD',
    EnableConversationSplitWorker: 'ENABLE_CONVERSATION_SPLIT_WORKER',
    EnableDailyDazzle: 'ENABLE_DAILY_DAZZLE',
    EnableDailyDazzleQuiet: 'ENABLE_DAILY_DAZZLE_QUIET',
    EnableDeleteUserWorker: 'ENABLE_DELETE_USER_WORKER',
    EnableIdeaGenerationWorker: 'ENABLE_IDEA_GENERATION_WORKER',
    EnableIdentityInfoWorker: 'ENABLE_IDENTITY_INFO_WORKER',
    EnableClusteringWorker: 'ENABLE_CLUSTERING_WORKER',
    EnableMemoryExtractionWorker: 'ENABLE_MEMORY_EXTRACTION_WORKER',
    EnablePhotoGroupingWorker: 'ENABLE_PHOTO_GROUPING_WORKER',
    EnablePhotoShareSuggestionWorker: 'ENABLE_PHOTO_SHARE_SUGGESTION_WORKER',
    EnablePhotoVectorWorker: 'ENABLE_PHOTO_VECTOR_WORKER',
    EnableIdeaStageWorker: 'ENABLE_IDEA_STAGE_WORKER',
    EnableOnboardingIdeaWorker: 'ENABLE_ONBOARDING_IDEA_WORKER',
    EnableProfileLabWorker: 'ENABLE_PROFILE_LAB_WORKER',
    EnableProfileWorker: 'ENABLE_PROFILE_WORKER',
    EnableRefreshIdeaWorker: 'ENABLE_REFRESH_IDEA_WORKER',
    EnableSendNotificationWorker: 'ENABLE_SEND_NOTIFICATION_WORKER',
    EnableOnboardingPhotoWorker: 'ENABLE_ONBOARDING_PHOTO_WORKER',
    EnableRealtimePhotoWorker: 'ENABLE_REALTIME_PHOTO_WORKER',
    EnableBackfillPhotoWorker: 'ENABLE_BACKFILL_PHOTO_WORKER',
    EnableCalendarChatTool: 'ENABLE_CALENDAR_CHAT_TOOL',
    EnableConciergeTools: 'ENABLE_CONCIERGE_TOOLS',
    EnableCalendarIdeasTool: 'ENABLE_CALENDAR_IDEAS_TOOL',
    EnableCalendarVectorWorker: 'ENABLE_CALENDAR_VECTOR_WORKER',
    EnableSuggestionWorker: 'ENABLE_SUGGESTION_WORKER',
    EnableTaskStatusWorkerWorker: 'ENABLE_TASK_STATUS_WORKER_WORKER',
    EnableUserNameExtractionWorker: 'ENABLE_USER_NAME_EXTRACTION_WORKER',
    EnableVisitInsightWorker: 'ENABLE_VISIT_INSIGHT_WORKER',
    EnableEvalRunWorker: 'ENABLE_EVAL_RUN_WORKER',
    EnableProfileInsightWorker: 'ENABLE_PROFILE_INSIGHT_WORKER',
    EnableNsfwModeration: 'ENABLE_NSFW_MODERATION',
    ModelClaudeHaikuUnavailable: 'MODEL_CLAUDE_HAIKU_UNAVAILABLE',
    ModelClaudeSonnetUnavailable: 'MODEL_CLAUDE_SONNET_UNAVAILABLE',
    ModelClaudeOpusUnavailable: 'MODEL_CLAUDE_OPUS_UNAVAILABLE',
    ModelGeminiProUnavailable: 'MODEL_GEMINI_PRO_UNAVAILABLE',
    ModelGeminiFlashUnavailable: 'MODEL_GEMINI_FLASH_UNAVAILABLE',
    ModelGeminiFlashLiteUnavailable: 'MODEL_GEMINI_FLASH_LITE_UNAVAILABLE',
    ModelGroqUnavailable: 'MODEL_GROQ_UNAVAILABLE',
    ModelCerebrasUnavailable: 'MODEL_CEREBRAS_UNAVAILABLE',
    EnableWelcomeEmail: 'ENABLE_WELCOME_EMAIL',
    TextStageRouting: 'TEXT_STAGE_ROUTING',
    UseModelNativeSdk: 'USE_MODEL_NATIVE_SDK',
    EnableMcp: 'ENABLE_MCP'
};
/**
 * Type of item being given feedback.
 */
export const FeedbackItemType = {
    Insight: 'INSIGHT',
    Idea: 'IDEA',
    Conversation: 'CONVERSATION',
    Suggestion: 'SUGGESTION'
};
/**
 * Positive/negative feedback sentiment.
 */
export const FeedbackSentiment = {
    Positive: 'POSITIVE',
    Negative: 'NEGATIVE'
};
export const FixSelfContentTypeEnum = {
    FixSelf: 'FIX_SELF'
};
export const FixVendorContentTypeEnum = {
    FixVendor: 'FIX_VENDOR'
};
export const FoodContentTypeEnum = {
    Food: 'FOOD'
};
export const GenericContentTypeEnum = {
    Generic: 'GENERIC'
};
export const IdeaActionActionTypeEnum = {
    Idea: 'idea'
};
/**
 * Valid color values for idea cards.
 */
export const IdeaColor = {
    Yellow: 'yellow',
    Orange: 'orange',
    Red: 'red',
    Magenta: 'magenta',
    Blue: 'blue',
    Aqua: 'aqua',
    Green: 'green'
};
export const IdeasContentTypeEnum = {
    Ideas: 'IDEAS'
};
export const IdentifyContentTypeEnum = {
    Identify: 'IDENTIFY'
};
export const ImageUrlContentTypeEnum = {
    ImageUrl: 'image_url'
};
/**
 * Status of an insight message.
 */
export const InsightStatus = {
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
};
export const LinkActionActionTypeEnum = {
    Link: 'link'
};
/**
 * Message role in conversation.
 */
export const MessageRole = {
    System: 'system',
    User: 'user',
    Assistant: 'assistant'
};
/**
 * Notification channel
 */
export const NotificationChannel = {
    Push: 'PUSH',
    Text: 'TEXT',
    Email: 'EMAIL'
};
/**
 * User onboarding status
 */
export const OnboardStatus = {
    App: 'APP',
    AppNoPhotos: 'APP_NO_PHOTOS',
    Web: 'WEB'
};
/**
 * Onboarding event types.
 */
export const OnboardingEventType = {
    UserAuthenticated: 'user_authenticated',
    PhotosFullAccessGranted: 'photos_full_access_granted',
    PhotosLimitedAccessGranted: 'photos_limited_access_granted',
    PhotosAccessDenied: 'photos_access_denied',
    QuickSuggestionTriggered: 'quick_suggestion_triggered',
    QuickSuggestionCompleted: 'quick_suggestion_completed',
    PhotoEmbeddingTriggered: 'photo_embedding_triggered',
    PhotoEmbeddingCompleted: 'photo_embedding_completed',
    SimilarityClusteringTriggered: 'similarity_clustering_triggered',
    SimilarityClusteringCompleted: 'similarity_clustering_completed',
    VisitClusteringTriggered: 'visit_clustering_triggered',
    VisitClusteringCompleted: 'visit_clustering_completed',
    LocationGeocodingTriggered: 'location_geocoding_triggered',
    LocationGeocodingCompleted: 'location_geocoding_completed',
    ProfileGenerationTriggered: 'profile_generation_triggered',
    ProfileGenerationCompleted: 'profile_generation_completed',
    IdeaGenerationTriggered: 'idea_generation_triggered',
    IdeaGenerationCompleted: 'idea_generation_completed',
    SuggestionGenerationTriggered: 'suggestion_generation_triggered',
    SuggestionGenerationCompleted: 'suggestion_generation_completed',
    FirstUserText: 'first_user_text'
};
/**
 * Opt-out process result
 */
export const OptOutResult = {
    OptOutInitiated: 'OPT_OUT_INITIATED',
    OptOutCompleted: 'OPT_OUT_COMPLETED'
};
export const OrderActionActionTypeEnum = {
    Order: 'order'
};
/**
 * Order processing status with enforced state machine transitions.  Valid state transitions: - SUGGESTION_PENDING -> [CONFIRMED_BY_DAZZLE, DECLINED_BY_DAZZLE] - CONFIRMED_BY_DAZZLE -> [CONFIRMED_BY_USER, DECLINED_BY_USER, ORDER_CLOSED] - CONFIRMED_BY_USER -> [ORDER_PENDING, ORDER_CLOSED] - ORDER_PENDING -> [PAYMENT_COMPLETED, PAYMENT_FAILED, ORDER_CLOSED] - PAYMENT_COMPLETED -> [ORDER_COMPLETED] - PAYMENT_FAILED -> [PAYMENT_COMPLETED, ORDER_CLOSED] - ORDER_COMPLETED -> [ORDER_CLOSED]  Terminal states (no further transitions): - DECLINED_BY_DAZZLE - DECLINED_BY_USER - ORDER_CLOSED
 */
export const OrderStatus = {
    OrderPending: 'ORDER_PENDING',
    PaymentCompleted: 'PAYMENT_COMPLETED',
    PaymentFailed: 'PAYMENT_FAILED',
    OrderCompleted: 'ORDER_COMPLETED',
    SuggestionPending: 'SUGGESTION_PENDING',
    ConfirmedByDazzle: 'CONFIRMED_BY_DAZZLE',
    DeclinedByDazzle: 'DECLINED_BY_DAZZLE',
    ConfirmedByUser: 'CONFIRMED_BY_USER',
    DeclinedByUser: 'DECLINED_BY_USER',
    OrderClosed: 'ORDER_CLOSED',
    ResearchPending: 'RESEARCH_PENDING'
};
/**
 * Type of order.
 */
export const OrderType = {
    Product: 'PRODUCT',
    Service: 'SERVICE',
    Concierge: 'CONCIERGE'
};
export const PaymentActionActionTypeEnum = {
    Payment: 'payment'
};
export const PaymentActionPaymentTypeEnum = {
    AddCard: 'add_card',
    PayNow: 'pay_now'
};
/**
 * Status of photo groups
 */
export const PhotoGroupStatus = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Dismissed: 'DISMISSED'
};
export const PhotoRefContentTypeEnum = {
    PhotoRef: 'photo_ref'
};
/**
 * PII type enum
 */
export const PiiType = {
    Phone: 'phone',
    Email: 'email'
};
/**
 * Product identifiers
 */
export const Product = {
    Dazzle: 'DAZZLE',
    Compass: 'COMPASS',
    DazzleDevPreview: 'DAZZLE_DEV_PREVIEW'
};
export const ProductContentTypeEnum = {
    Product: 'PRODUCT'
};
/**
 * Dataset types for export.
 */
export const ProfileLabDatasetType = {
    User: 'user',
    Visits: 'visits',
    Profile: 'profile'
};
/**
 * Photo selection operations.
 */
export const ProfileLabSelectionOperation = {
    Random: 'random',
    Latest: 'latest',
    Ranked: 'ranked',
    Stage: 'stage'
};
/**
 * Types of prompts
 */
export const PromptType = {
    ChatSystemPrompt: 'CHAT_SYSTEM_PROMPT',
    ConversationSplitSystemPrompt: 'CONVERSATION_SPLIT_SYSTEM_PROMPT',
    ConversationTitleIntentPrompt: 'CONVERSATION_TITLE_INTENT_PROMPT',
    MemorySystemPrompt: 'MEMORY_SYSTEM_PROMPT',
    MemoryUserPrompt: 'MEMORY_USER_PROMPT',
    IntentSystemPrompt: 'INTENT_SYSTEM_PROMPT',
    FreeformIntentSystemPrompt: 'FREEFORM_INTENT_SYSTEM_PROMPT',
    OnboardingProductIntro: 'ONBOARDING_PRODUCT_INTRO',
    OnboardingNameRequest: 'ONBOARDING_NAME_REQUEST',
    OnboardingNameExtraction: 'ONBOARDING_NAME_EXTRACTION',
    OnboardingNameComment: 'ONBOARDING_NAME_COMMENT',
    OnboardingStarSignGuess: 'ONBOARDING_STAR_SIGN_GUESS',
    OnboardingStarSignGame: 'ONBOARDING_STAR_SIGN_GAME',
    OnboardingStarSignInvitation: 'ONBOARDING_STAR_SIGN_INVITATION',
    OnboardingAppDownload: 'ONBOARDING_APP_DOWNLOAD',
    OnboardingFlightIntro: 'ONBOARDING_FLIGHT_INTRO',
    OnboardingFlightExampleIntro: 'ONBOARDING_FLIGHT_EXAMPLE_INTRO',
    OnboardingFlightExampleOutro: 'ONBOARDING_FLIGHT_EXAMPLE_OUTRO',
    OnboardingPhotoPrompt: 'ONBOARDING_PHOTO_PROMPT',
    ProfileSystemPrompt: 'PROFILE_SYSTEM_PROMPT',
    IntentExtractCalendar: 'INTENT_EXTRACT_CALENDAR',
    IntentExtractContact: 'INTENT_EXTRACT_CONTACT',
    IntentExtractOccasions: 'INTENT_EXTRACT_OCCASIONS',
    IntentExtractProduct: 'INTENT_EXTRACT_PRODUCT',
    IntentExtractFood: 'INTENT_EXTRACT_FOOD',
    IntentExtractFix: 'INTENT_EXTRACT_FIX',
    IntentExtractFixSelf: 'INTENT_EXTRACT_FIX_SELF',
    IntentExtractFixVendor: 'INTENT_EXTRACT_FIX_VENDOR',
    IntentExtractIdentify: 'INTENT_EXTRACT_IDENTIFY',
    IntentExtractTranscribe: 'INTENT_EXTRACT_TRANSCRIBE',
    IntentExtractRemind: 'INTENT_EXTRACT_REMIND',
    IntentExtractFollowup: 'INTENT_EXTRACT_FOLLOWUP',
    IntentExtractShareableMoment: 'INTENT_EXTRACT_SHAREABLE_MOMENT',
    IntentExtractCoordinate: 'INTENT_EXTRACT_COORDINATE',
    IntentExtractReferenceOrStatus: 'INTENT_EXTRACT_REFERENCE_OR_STATUS',
    IntentExtractQrcode: 'INTENT_EXTRACT_QRCODE',
    IntentExtractFile: 'INTENT_EXTRACT_FILE',
    IntentExtractHealth: 'INTENT_EXTRACT_HEALTH',
    TitleExtractSharePhotos: 'TITLE_EXTRACT_SHARE_PHOTOS',
    PhotoCaption: 'PHOTO_CAPTION',
    PhotoIdExtraction: 'PHOTO_ID_EXTRACTION',
    PhotoGroupingSystemPrompt: 'PHOTO_GROUPING_SYSTEM_PROMPT',
    PhotoKeywordsExtraction: 'PHOTO_KEYWORDS_EXTRACTION',
    AestheticScorePrompt: 'AESTHETIC_SCORE_PROMPT',
    IdeasCuratedSystemPrompt: 'IDEAS_CURATED_SYSTEM_PROMPT',
    IdeasFashionProfilePrompt: 'IDEAS_FASHION_PROFILE_PROMPT',
    IdeasTravelProfilePrompt: 'IDEAS_TRAVEL_PROFILE_PROMPT',
    IdeasActivitiesProfilePrompt: 'IDEAS_ACTIVITIES_PROFILE_PROMPT',
    IdeasRerankPrompt: 'IDEAS_RERANK_PROMPT',
    IdeasRestaurantsProfilePrompt: 'IDEAS_RESTAURANTS_PROFILE_PROMPT',
    IdeasHotelsProfilePrompt: 'IDEAS_HOTELS_PROFILE_PROMPT',
    IdeasLearningProfilePrompt: 'IDEAS_LEARNING_PROFILE_PROMPT',
    IdeasGiftsProfilePrompt: 'IDEAS_GIFTS_PROFILE_PROMPT',
    IdeasGadgetsProfilePrompt: 'IDEAS_GADGETS_PROFILE_PROMPT',
    IdeasConcertsProfilePrompt: 'IDEAS_CONCERTS_PROFILE_PROMPT',
    IdeasPlaylistsProfilePrompt: 'IDEAS_PLAYLISTS_PROFILE_PROMPT',
    IdeasPersonalCareProfilePrompt: 'IDEAS_PERSONAL_CARE_PROFILE_PROMPT',
    IdeasClassesProfilePrompt: 'IDEAS_CLASSES_PROFILE_PROMPT',
    IdeasPodcastsProfilePrompt: 'IDEAS_PODCASTS_PROFILE_PROMPT',
    OnboardingAppInstallAgent: 'ONBOARDING_APP_INSTALL_AGENT',
    OnboardingPermissionAgent: 'ONBOARDING_PERMISSION_AGENT',
    UserNameExtraction: 'USER_NAME_EXTRACTION',
    UserNameExtractionSystemPrompt: 'USER_NAME_EXTRACTION_SYSTEM_PROMPT',
    OrderChatAgentPrompt: 'ORDER_CHAT_AGENT_PROMPT',
    OrderIntentClassifierPrompt: 'ORDER_INTENT_CLASSIFIER_PROMPT',
    SuggestionDuplicateCheckSystemPrompt: 'SUGGESTION_DUPLICATE_CHECK_SYSTEM_PROMPT',
    SuggestionDuplicateCheckUserPrompt: 'SUGGESTION_DUPLICATE_CHECK_USER_PROMPT',
    PhotoHighlightAnalysisPrompt: 'PHOTO_HIGHLIGHT_ANALYSIS_PROMPT',
    PhotoShareMoodPrompt: 'PHOTO_SHARE_MOOD_PROMPT',
    InsightVisitPrompt: 'INSIGHT_VISIT_PROMPT',
    InsightProfilePrompt: 'INSIGHT_PROFILE_PROMPT',
    DazzleCapabilities: 'DAZZLE_CAPABILITIES',
    ThoughtSummaryPrompt: 'THOUGHT_SUMMARY_PROMPT',
    ThoughtPreviewPrompt: 'THOUGHT_PREVIEW_PROMPT',
    GreetingSystemPrompt: 'GREETING_SYSTEM_PROMPT',
    UrlRelevanceCheckPrompt: 'URL_RELEVANCE_CHECK_PROMPT',
    ProfileStageHomeTemplate: 'PROFILE_STAGE_HOME_TEMPLATE',
    ProfileStageTripsTemplate: 'PROFILE_STAGE_TRIPS_TEMPLATE',
    ProfileStagePeopleTemplate: 'PROFILE_STAGE_PEOPLE_TEMPLATE',
    ProfileStagePeopleQuestions: 'PROFILE_STAGE_PEOPLE_QUESTIONS',
    ProfileStageHomeLivingTemplate: 'PROFILE_STAGE_HOME_LIVING_TEMPLATE',
    ProfileStageHomeLivingQuestions: 'PROFILE_STAGE_HOME_LIVING_QUESTIONS',
    ProfileStageActivitiesTemplate: 'PROFILE_STAGE_ACTIVITIES_TEMPLATE',
    ProfileStageActivitiesQuestions: 'PROFILE_STAGE_ACTIVITIES_QUESTIONS',
    ProfileStageActivitiesCombiner: 'PROFILE_STAGE_ACTIVITIES_COMBINER',
    ProfileStageFashionStyleTemplate: 'PROFILE_STAGE_FASHION_STYLE_TEMPLATE',
    ProfileStageFashionStyleQuestions: 'PROFILE_STAGE_FASHION_STYLE_QUESTIONS',
    ProfileStageFashionStyleCombiner: 'PROFILE_STAGE_FASHION_STYLE_COMBINER',
    ProfileStageBrandingTemplate: 'PROFILE_STAGE_BRANDING_TEMPLATE',
    ProfileStageBrandingQuestions: 'PROFILE_STAGE_BRANDING_QUESTIONS',
    ProfileStageSpendingTemplate: 'PROFILE_STAGE_SPENDING_TEMPLATE',
    ProfileStageDefaultCombiner: 'PROFILE_STAGE_DEFAULT_COMBINER',
    PlatformQuerySystemPrompt: 'PLATFORM_QUERY_SYSTEM_PROMPT'
};
export const QRCodeContentTypeEnum = {
    Qrcode: 'QRCODE'
};
/**
 * Quality feedback from user about a suggestion.
 */
export const QualityFeedback = {
    None: 'NONE',
    Good: 'GOOD',
    Neutral: 'NEUTRAL',
    Bad: 'BAD'
};
export const ReminderActionActionTypeEnum = {
    Reminder: 'reminder'
};
export const ReminderContentTypeEnum = {
    Remind: 'REMIND'
};
/**
 * Reminder status
 */
export const ReminderStatus = {
    Pending: 'PENDING',
    Dismissed: 'DISMISSED'
};
/**
 * Result of sending verification code
 */
export const SendVerificationCodeResult = {
    Success: 'SUCCESS',
    InvalidPii: 'INVALID_PII',
    TooManyTries: 'TOO_MANY_TRIES',
    InvalidToken: 'INVALID_TOKEN'
};
export const SharePhotosActionActionTypeEnum = {
    SharePhotos: 'share_photos'
};
export const SharePhotosContentTypeEnum = {
    SharePhotos: 'SHARE_PHOTOS'
};
/**
 * Sort field for user queries.
 */
export const SortBy = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
};
/**
 * Sort order for queries.
 */
export const SortOrder = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
export const StreamingChatCompleteTypeEnum = {
    Complete: 'complete'
};
export const StreamingChatDeltaTypeEnum = {
    Delta: 'delta'
};
export const StreamingChatTimingTypeEnum = {
    Timing: 'timing'
};
/**
 * Status of suggestions
 */
export const SuggestionStatus = {
    PendingReview: 'PENDING_REVIEW',
    Pending: 'PENDING',
    Seen: 'SEEN',
    Dismissed: 'DISMISSED',
    ActedOn: 'ACTED_ON',
    Invalid: 'INVALID'
};
/**
 * Types of suggestions
 */
export const SuggestionType = {
    Calendar: 'CALENDAR',
    Completed: 'COMPLETED',
    Contact: 'CONTACT',
    Coordinate: 'COORDINATE',
    File: 'FILE',
    Fix: 'FIX',
    FixSelf: 'FIX_SELF',
    FixVendor: 'FIX_VENDOR',
    Food: 'FOOD',
    Freeform: 'FREEFORM',
    Health: 'HEALTH',
    Identify: 'IDENTIFY',
    Occasions: 'OCCASIONS',
    Other: 'OTHER',
    Product: 'PRODUCT',
    Qrcode: 'QRCODE',
    ReferenceOrStatus: 'REFERENCE_OR_STATUS',
    Remind: 'REMIND',
    ShareableMoment: 'SHAREABLE_MOMENT',
    Transcribe: 'TRANSCRIBE',
    AutoTag: 'AUTO_TAG',
    FaceTagging: 'FACE_TAGGING',
    Ideas: 'IDEAS',
    OnboardingTravelSuggestion: 'ONBOARDING_TRAVEL_SUGGESTION',
    ProfileStats: 'PROFILE_STATS',
    SharePhotos: 'SHARE_PHOTOS',
    TimeSensitive: 'TIME_SENSITIVE'
};
export const TextContentTypeEnum = {
    Text: 'text'
};
export const ThoughtMessageTypeEnum = {
    Thought: 'thought'
};
export const TimerTaskAction = {
    Enable: 'ENABLE',
    Disable: 'DISABLE',
    SetFrequency: 'SET_FREQUENCY'
};
/**
 * Timer task name identifiers.
 */
export const TimerTaskName = {
    ConversationSplitScan: 'CONVERSATION_SPLIT_SCAN',
    DailyDazzle: 'DAILY_DAZZLE',
    MemoryExtractionScan: 'MEMORY_EXTRACTION_SCAN',
    PhotoShareSuggestionRequeue: 'PHOTO_SHARE_SUGGESTION_REQUEUE',
    PhotoSyncTrigger: 'PHOTO_SYNC_TRIGGER',
    RefreshIdeaScan: 'REFRESH_IDEA_SCAN',
    SendNotification: 'SEND_NOTIFICATION',
    ModelHealthPing: 'MODEL_HEALTH_PING',
    WorkerStatusMetrics: 'WORKER_STATUS_METRICS'
};
/**
 * Type of trace event.
 */
export const TraceEventType = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9
};
/**
 * Origin of a trace.
 */
export const TraceSource = {
    NUMBER_1: 1,
    NUMBER_2: 2
};
/**
 * Status of a trace.
 */
export const TraceStatus = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
};
export const TranscriptionActionActionTypeEnum = {
    Transcription: 'transcription'
};
export const TranscriptionContentTypeEnum = {
    Transcribe: 'TRANSCRIBE'
};
/**
 * Transit types for boarding passes.
 */
export const TransitType = {
    Air: 'air',
    Boat: 'boat',
    Bus: 'bus',
    Train: 'train',
    Generic: 'generic'
};
/**
 * Result of code verification
 */
export const VerifyCodeResult = {
    Success: 'SUCCESS',
    InvalidCode: 'INVALID_CODE',
    CodeExpired: 'CODE_EXPIRED',
    TooManyTries: 'TOO_MANY_TRIES'
};
export const WalletPassActionActionTypeEnum = {
    WalletPass: 'wallet_pass'
};
/**
 * Apple Wallet pass types (matches PassKit API values).
 */
export const WalletPassType = {
    Generic: 'generic',
    EventTicket: 'eventTicket',
    BoardingPass: 'boardingPass',
    StoreCard: 'storeCard',
    Coupon: 'coupon'
};
/**
 * DefaultApi - axios parameter creator
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Refetch access token using refresh token in the cookie.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AccessTokenRequest} accessTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAccessTokenCookiesPost: (xUserAgent_1, xDeviceID_1, accessTokenRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, accessTokenRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, accessTokenRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authAccessTokenCookiesPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authAccessTokenCookiesPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'accessTokenRequest' is not null or undefined
            assertParamExists('authAccessTokenCookiesPost', 'accessTokenRequest', accessTokenRequest);
            const localVarPath = `/api/auth/access-token-cookies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Refetch access token using refresh token in the header.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AccessTokenRequest} accessTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAccessTokenPost: (xUserAgent_1, xDeviceID_1, accessTokenRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, accessTokenRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, accessTokenRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authAccessTokenPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authAccessTokenPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'accessTokenRequest' is not null or undefined
            assertParamExists('authAccessTokenPost', 'accessTokenRequest', accessTokenRequest);
            const localVarPath = `/api/auth/access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(accessTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete refresh token cookie.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authDeleteRefreshTokenPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authDeleteRefreshTokenPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authDeleteRefreshTokenPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authDeleteRefreshTokenPost', 'body', body);
            const localVarPath = `/api/auth/delete-refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all users for internal use.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllUsersInternalRequest} getAllUsersInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetAllUsersInternalPost: (xUserAgent_1, xDeviceID_1, getAllUsersInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getAllUsersInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getAllUsersInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authGetAllUsersInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authGetAllUsersInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getAllUsersInternalRequest' is not null or undefined
            assertParamExists('authGetAllUsersInternalPost', 'getAllUsersInternalRequest', getAllUsersInternalRequest);
            const localVarPath = `/api/auth/get-all-users-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAllUsersInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Opt out of service.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOptOutPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authOptOutPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authOptOutPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('authOptOutPost', 'body', body);
            const localVarPath = `/api/auth/opt-out`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send verification code to user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendVerificationCodeRequest} sendVerificationCodeRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSendVerificationCodePost: (xUserAgent_1, xDeviceID_1, sendVerificationCodeRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, sendVerificationCodeRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, sendVerificationCodeRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authSendVerificationCodePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authSendVerificationCodePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'sendVerificationCodeRequest' is not null or undefined
            assertParamExists('authSendVerificationCodePost', 'sendVerificationCodeRequest', sendVerificationCodeRequest);
            const localVarPath = `/api/auth/send-verification-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendVerificationCodeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sign in with verified code.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SignInRequest} signInRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignInPost: (xUserAgent_1, xDeviceID_1, signInRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, signInRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, signInRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authSignInPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authSignInPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'signInRequest' is not null or undefined
            assertParamExists('authSignInPost', 'signInRequest', signInRequest);
            const localVarPath = `/api/auth/sign-in`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(signInRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update user device token.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDeviceTokenRequest} updateDeviceTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateDeviceTokenPost: (xUserAgent_1, xDeviceID_1, updateDeviceTokenRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDeviceTokenRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDeviceTokenRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authUpdateDeviceTokenPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authUpdateDeviceTokenPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDeviceTokenRequest' is not null or undefined
            assertParamExists('authUpdateDeviceTokenPost', 'updateDeviceTokenRequest', updateDeviceTokenRequest);
            const localVarPath = `/api/auth/update-device-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeviceTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Verify code.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {VerifyCodeRequest} verifyCodeRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyCodePost: (xUserAgent_1, xDeviceID_1, verifyCodeRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, verifyCodeRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, verifyCodeRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('authVerifyCodePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('authVerifyCodePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'verifyCodeRequest' is not null or undefined
            assertParamExists('authVerifyCodePost', 'verifyCodeRequest', verifyCodeRequest);
            const localVarPath = `/api/auth/verify-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(verifyCodeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sync calendars and events.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CalendarSyncRequest} calendarSyncRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarSyncPost: (xUserAgent_1, xDeviceID_1, calendarSyncRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, calendarSyncRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, calendarSyncRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('calendarSyncPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('calendarSyncPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'calendarSyncRequest' is not null or undefined
            assertParamExists('calendarSyncPost', 'calendarSyncRequest', calendarSyncRequest);
            const localVarPath = `/api/dazzle/user/calendar/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(calendarSyncRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * <br/>Returns Server-Sent Events (text/event-stream). Each event contains a JSON object<br/>with one of these types: ThoughtMessage, StreamingChatDelta, StreamingChatComplete, or StreamingChatTiming.<br/><br/>Event format:<br/>- ThoughtMessage: {\"type\": \"thought\", \"message\": \"...\", \"tool_name\": \"...\"}<br/>- StreamingChatDelta: {\"type\": \"delta\", \"message\": \"...\"}<br/>- StreamingChatComplete: {\"type\": \"complete\", \"message\": {...}}<br/>- StreamingChatTiming: {\"type\": \"timing\", \"total_ms\": ..., \"breakdown\": {...}}
         * @summary Process a streaming chat completion request.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ChatRequest} chatRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStreamPost: (xUserAgent_1, xDeviceID_1, chatRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, chatRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, chatRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('chatStreamPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('chatStreamPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'chatRequest' is not null or undefined
            assertParamExists('chatStreamPost', 'chatRequest', chatRequest);
            const localVarPath = `/api/dazzle/agent/chat/stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(chatRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabConfirmDuplicatesRequest} clusteringLabConfirmDuplicatesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesConfirmPost: (xUserAgent_1, xDeviceID_1, clusteringLabConfirmDuplicatesRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabConfirmDuplicatesRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabConfirmDuplicatesRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabDuplicatesConfirmPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabDuplicatesConfirmPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabConfirmDuplicatesRequest' is not null or undefined
            assertParamExists('clusteringLabDuplicatesConfirmPost', 'clusteringLabConfirmDuplicatesRequest', clusteringLabConfirmDuplicatesRequest);
            const localVarPath = `/api/dazzle/clustering-lab/duplicates/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabConfirmDuplicatesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListDuplicateSetsRequest} clusteringLabListDuplicateSetsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesListSetsPost: (xUserAgent_1, xDeviceID_1, clusteringLabListDuplicateSetsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabListDuplicateSetsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabListDuplicateSetsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabDuplicatesListSetsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabDuplicatesListSetsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabListDuplicateSetsRequest' is not null or undefined
            assertParamExists('clusteringLabDuplicatesListSetsPost', 'clusteringLabListDuplicateSetsRequest', clusteringLabListDuplicateSetsRequest);
            const localVarPath = `/api/dazzle/clustering-lab/duplicates/list-sets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabListDuplicateSetsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabMarkNotDuplicateRequest} clusteringLabMarkNotDuplicateRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesMarkNotDuplicatePost: (xUserAgent_1, xDeviceID_1, clusteringLabMarkNotDuplicateRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabMarkNotDuplicateRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabMarkNotDuplicateRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabDuplicatesMarkNotDuplicatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabDuplicatesMarkNotDuplicatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabMarkNotDuplicateRequest' is not null or undefined
            assertParamExists('clusteringLabDuplicatesMarkNotDuplicatePost', 'clusteringLabMarkNotDuplicateRequest', clusteringLabMarkNotDuplicateRequest);
            const localVarPath = `/api/dazzle/clustering-lab/duplicates/mark-not-duplicate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabMarkNotDuplicateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabExportRequest} clusteringLabExportRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabExportPost: (xUserAgent_1, xDeviceID_1, clusteringLabExportRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabExportRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabExportRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabExportPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabExportPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabExportRequest' is not null or undefined
            assertParamExists('clusteringLabExportPost', 'clusteringLabExportRequest', clusteringLabExportRequest);
            const localVarPath = `/api/dazzle/clustering-lab/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabExportRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabCreateGroupRequest} clusteringLabCreateGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsCreatePost: (xUserAgent_1, xDeviceID_1, clusteringLabCreateGroupRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabCreateGroupRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabCreateGroupRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabGroupsCreatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabGroupsCreatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabCreateGroupRequest' is not null or undefined
            assertParamExists('clusteringLabGroupsCreatePost', 'clusteringLabCreateGroupRequest', clusteringLabCreateGroupRequest);
            const localVarPath = `/api/dazzle/clustering-lab/groups/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabCreateGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabDeleteGroupRequest} clusteringLabDeleteGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsDeletePost: (xUserAgent_1, xDeviceID_1, clusteringLabDeleteGroupRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabDeleteGroupRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabDeleteGroupRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabGroupsDeletePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabGroupsDeletePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabDeleteGroupRequest' is not null or undefined
            assertParamExists('clusteringLabGroupsDeletePost', 'clusteringLabDeleteGroupRequest', clusteringLabDeleteGroupRequest);
            const localVarPath = `/api/dazzle/clustering-lab/groups/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabDeleteGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListGroupsRequest} clusteringLabListGroupsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsListPost: (xUserAgent_1, xDeviceID_1, clusteringLabListGroupsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabListGroupsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabListGroupsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabGroupsListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabGroupsListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabListGroupsRequest' is not null or undefined
            assertParamExists('clusteringLabGroupsListPost', 'clusteringLabListGroupsRequest', clusteringLabListGroupsRequest);
            const localVarPath = `/api/dazzle/clustering-lab/groups/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabListGroupsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabUpdateGroupRequest} clusteringLabUpdateGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsUpdatePost: (xUserAgent_1, xDeviceID_1, clusteringLabUpdateGroupRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabUpdateGroupRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabUpdateGroupRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabGroupsUpdatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabGroupsUpdatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabUpdateGroupRequest' is not null or undefined
            assertParamExists('clusteringLabGroupsUpdatePost', 'clusteringLabUpdateGroupRequest', clusteringLabUpdateGroupRequest);
            const localVarPath = `/api/dazzle/clustering-lab/groups/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabUpdateGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabAssignMembersRequest} clusteringLabAssignMembersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabMembersAssignPost: (xUserAgent_1, xDeviceID_1, clusteringLabAssignMembersRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabAssignMembersRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabAssignMembersRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabMembersAssignPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabMembersAssignPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabAssignMembersRequest' is not null or undefined
            assertParamExists('clusteringLabMembersAssignPost', 'clusteringLabAssignMembersRequest', clusteringLabAssignMembersRequest);
            const localVarPath = `/api/dazzle/clustering-lab/members/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabAssignMembersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabUnassignMembersRequest} clusteringLabUnassignMembersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabMembersUnassignPost: (xUserAgent_1, xDeviceID_1, clusteringLabUnassignMembersRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabUnassignMembersRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabUnassignMembersRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabMembersUnassignPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabMembersUnassignPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabUnassignMembersRequest' is not null or undefined
            assertParamExists('clusteringLabMembersUnassignPost', 'clusteringLabUnassignMembersRequest', clusteringLabUnassignMembersRequest);
            const localVarPath = `/api/dazzle/clustering-lab/members/unassign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabUnassignMembersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListPhotosRequest} clusteringLabListPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabPhotosListPost: (xUserAgent_1, xDeviceID_1, clusteringLabListPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabListPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabListPhotosRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabPhotosListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabPhotosListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabListPhotosRequest' is not null or undefined
            assertParamExists('clusteringLabPhotosListPost', 'clusteringLabListPhotosRequest', clusteringLabListPhotosRequest);
            const localVarPath = `/api/dazzle/clustering-lab/photos/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabListPhotosRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabConfirmShareworthyRequest} clusteringLabConfirmShareworthyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabShareworthyConfirmPost: (xUserAgent_1, xDeviceID_1, clusteringLabConfirmShareworthyRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabConfirmShareworthyRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabConfirmShareworthyRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabShareworthyConfirmPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabShareworthyConfirmPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabConfirmShareworthyRequest' is not null or undefined
            assertParamExists('clusteringLabShareworthyConfirmPost', 'clusteringLabConfirmShareworthyRequest', clusteringLabConfirmShareworthyRequest);
            const localVarPath = `/api/dazzle/clustering-lab/shareworthy/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabConfirmShareworthyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListShareworthyRequest} clusteringLabListShareworthyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabShareworthyListPost: (xUserAgent_1, xDeviceID_1, clusteringLabListShareworthyRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clusteringLabListShareworthyRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clusteringLabListShareworthyRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('clusteringLabShareworthyListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('clusteringLabShareworthyListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clusteringLabListShareworthyRequest' is not null or undefined
            assertParamExists('clusteringLabShareworthyListPost', 'clusteringLabListShareworthyRequest', clusteringLabListShareworthyRequest);
            const localVarPath = `/api/dazzle/clustering-lab/shareworthy/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clusteringLabListShareworthyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Bulk delete conversations.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {BulkDeleteDzlConversationsRequest} bulkDeleteDzlConversationsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationBulkDeletePost: (xUserAgent_1, xDeviceID_1, bulkDeleteDzlConversationsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, bulkDeleteDzlConversationsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, bulkDeleteDzlConversationsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationBulkDeletePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationBulkDeletePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'bulkDeleteDzlConversationsRequest' is not null or undefined
            assertParamExists('conversationBulkDeletePost', 'bulkDeleteDzlConversationsRequest', bulkDeleteDzlConversationsRequest);
            const localVarPath = `/api/dazzle/conversation/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(bulkDeleteDzlConversationsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get conversation for any user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreateDzlConversationInternalRequest} createDzlConversationInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationCreateInternalPost: (xUserAgent_1, xDeviceID_1, createDzlConversationInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, createDzlConversationInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, createDzlConversationInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationCreateInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationCreateInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'createDzlConversationInternalRequest' is not null or undefined
            assertParamExists('conversationCreateInternalPost', 'createDzlConversationInternalRequest', createDzlConversationInternalRequest);
            const localVarPath = `/api/dazzle/conversation/create-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createDzlConversationInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get conversation for any user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DeleteDzlConversationInternalRequest} deleteDzlConversationInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationDeleteInternalPost: (xUserAgent_1, xDeviceID_1, deleteDzlConversationInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, deleteDzlConversationInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, deleteDzlConversationInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationDeleteInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationDeleteInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'deleteDzlConversationInternalRequest' is not null or undefined
            assertParamExists('conversationDeleteInternalPost', 'deleteDzlConversationInternalRequest', deleteDzlConversationInternalRequest);
            const localVarPath = `/api/dazzle/conversation/delete-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDzlConversationInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete conversation.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DeleteDzlConversationRequest} deleteDzlConversationRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationDeletePost: (xUserAgent_1, xDeviceID_1, deleteDzlConversationRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, deleteDzlConversationRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, deleteDzlConversationRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationDeletePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationDeletePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'deleteDzlConversationRequest' is not null or undefined
            assertParamExists('conversationDeletePost', 'deleteDzlConversationRequest', deleteDzlConversationRequest);
            const localVarPath = `/api/dazzle/conversation/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteDzlConversationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all conversations for user (internal endpoint).
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetConversationsInternalRequest} getConversationsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetConversationsInternalPost: (xUserAgent_1, xDeviceID_1, getConversationsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getConversationsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getConversationsInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationGetConversationsInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationGetConversationsInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getConversationsInternalRequest' is not null or undefined
            assertParamExists('conversationGetConversationsInternalPost', 'getConversationsInternalRequest', getConversationsInternalRequest);
            const localVarPath = `/api/dazzle/conversation/get-conversations-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getConversationsInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get conversation for any user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetConversationInternalRequest} getConversationInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetInternalPost: (xUserAgent_1, xDeviceID_1, getConversationInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getConversationInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getConversationInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationGetInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationGetInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getConversationInternalRequest' is not null or undefined
            assertParamExists('conversationGetInternalPost', 'getConversationInternalRequest', getConversationInternalRequest);
            const localVarPath = `/api/dazzle/conversation/get-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getConversationInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get single conversation.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDzlConversationRequest} getDzlConversationRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetPost: (xUserAgent_1, xDeviceID_1, getDzlConversationRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getDzlConversationRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getDzlConversationRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getDzlConversationRequest' is not null or undefined
            assertParamExists('conversationGetPost', 'getDzlConversationRequest', getDzlConversationRequest);
            const localVarPath = `/api/dazzle/conversation/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getDzlConversationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Increment copy count for a message.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {IncrementMessageCopyCountRequest} incrementMessageCopyCountRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationIncrementCopyCountPost: (xUserAgent_1, xDeviceID_1, incrementMessageCopyCountRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, incrementMessageCopyCountRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, incrementMessageCopyCountRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationIncrementCopyCountPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationIncrementCopyCountPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'incrementMessageCopyCountRequest' is not null or undefined
            assertParamExists('conversationIncrementCopyCountPost', 'incrementMessageCopyCountRequest', incrementMessageCopyCountRequest);
            const localVarPath = `/api/dazzle/conversation/increment-copy-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(incrementMessageCopyCountRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all conversations.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllDzlConversationsRequest} getAllDzlConversationsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationListPost: (xUserAgent_1, xDeviceID_1, getAllDzlConversationsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getAllDzlConversationsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getAllDzlConversationsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getAllDzlConversationsRequest' is not null or undefined
            assertParamExists('conversationListPost', 'getAllDzlConversationsRequest', getAllDzlConversationsRequest);
            const localVarPath = `/api/dazzle/conversation/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAllDzlConversationsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send message as Dazzle.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendDazzleMessageRequest} sendDazzleMessageRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationSendAsDazzlePost: (xUserAgent_1, xDeviceID_1, sendDazzleMessageRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, sendDazzleMessageRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, sendDazzleMessageRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('conversationSendAsDazzlePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('conversationSendAsDazzlePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'sendDazzleMessageRequest' is not null or undefined
            assertParamExists('conversationSendAsDazzlePost', 'sendDazzleMessageRequest', sendDazzleMessageRequest);
            const localVarPath = `/api/dazzle/conversation/send-as-dazzle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendDazzleMessageRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a new dataset entry.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlCreateDatasetEntryRequest} dzlCreateDatasetEntryRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetCreatePost: (xUserAgent_1, xDeviceID_1, dzlCreateDatasetEntryRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlCreateDatasetEntryRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlCreateDatasetEntryRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalDatasetCreatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalDatasetCreatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlCreateDatasetEntryRequest' is not null or undefined
            assertParamExists('evalDatasetCreatePost', 'dzlCreateDatasetEntryRequest', dzlCreateDatasetEntryRequest);
            const localVarPath = `/api/dazzle/eval/dataset/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlCreateDatasetEntryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Soft-delete a dataset entry.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlDeleteDatasetEntryRequest} dzlDeleteDatasetEntryRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetDeletePost: (xUserAgent_1, xDeviceID_1, dzlDeleteDatasetEntryRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlDeleteDatasetEntryRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlDeleteDatasetEntryRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalDatasetDeletePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalDatasetDeletePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlDeleteDatasetEntryRequest' is not null or undefined
            assertParamExists('evalDatasetDeletePost', 'dzlDeleteDatasetEntryRequest', dzlDeleteDatasetEntryRequest);
            const localVarPath = `/api/dazzle/eval/dataset/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlDeleteDatasetEntryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List dataset entries for a suite.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlListDatasetEntriesRequest} dzlListDatasetEntriesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetListPost: (xUserAgent_1, xDeviceID_1, dzlListDatasetEntriesRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlListDatasetEntriesRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlListDatasetEntriesRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalDatasetListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalDatasetListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlListDatasetEntriesRequest' is not null or undefined
            assertParamExists('evalDatasetListPost', 'dzlListDatasetEntriesRequest', dzlListDatasetEntriesRequest);
            const localVarPath = `/api/dazzle/eval/dataset/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlListDatasetEntriesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List candidate photos for seeding the golden dataset.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlListSeedCandidatesRequest} dzlListSeedCandidatesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetSeedCandidatesPost: (xUserAgent_1, xDeviceID_1, dzlListSeedCandidatesRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlListSeedCandidatesRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlListSeedCandidatesRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalDatasetSeedCandidatesPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalDatasetSeedCandidatesPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlListSeedCandidatesRequest' is not null or undefined
            assertParamExists('evalDatasetSeedCandidatesPost', 'dzlListSeedCandidatesRequest', dzlListSeedCandidatesRequest);
            const localVarPath = `/api/dazzle/eval/dataset/seed-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlListSeedCandidatesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a dataset entry.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlUpdateDatasetEntryRequest} dzlUpdateDatasetEntryRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetUpdatePost: (xUserAgent_1, xDeviceID_1, dzlUpdateDatasetEntryRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlUpdateDatasetEntryRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlUpdateDatasetEntryRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalDatasetUpdatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalDatasetUpdatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlUpdateDatasetEntryRequest' is not null or undefined
            assertParamExists('evalDatasetUpdatePost', 'dzlUpdateDatasetEntryRequest', dzlUpdateDatasetEntryRequest);
            const localVarPath = `/api/dazzle/eval/dataset/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlUpdateDatasetEntryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get eval run status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlGetEvalRunRequest} dzlGetEvalRunRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunGetPost: (xUserAgent_1, xDeviceID_1, dzlGetEvalRunRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlGetEvalRunRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlGetEvalRunRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalRunGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalRunGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlGetEvalRunRequest' is not null or undefined
            assertParamExists('evalRunGetPost', 'dzlGetEvalRunRequest', dzlGetEvalRunRequest);
            const localVarPath = `/api/dazzle/eval/run/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlGetEvalRunRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List recent eval runs.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlListEvalRunsRequest} dzlListEvalRunsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunListPost: (xUserAgent_1, xDeviceID_1, dzlListEvalRunsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlListEvalRunsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlListEvalRunsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalRunListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalRunListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlListEvalRunsRequest' is not null or undefined
            assertParamExists('evalRunListPost', 'dzlListEvalRunsRequest', dzlListEvalRunsRequest);
            const localVarPath = `/api/dazzle/eval/run/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlListEvalRunsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get results for an eval run.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlGetEvalRunResultsRequest} dzlGetEvalRunResultsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunResultsPost: (xUserAgent_1, xDeviceID_1, dzlGetEvalRunResultsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlGetEvalRunResultsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlGetEvalRunResultsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalRunResultsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalRunResultsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlGetEvalRunResultsRequest' is not null or undefined
            assertParamExists('evalRunResultsPost', 'dzlGetEvalRunResultsRequest', dzlGetEvalRunResultsRequest);
            const localVarPath = `/api/dazzle/eval/run/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlGetEvalRunResultsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Start a new eval run.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlStartEvalRunRequest} dzlStartEvalRunRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunStartPost: (xUserAgent_1, xDeviceID_1, dzlStartEvalRunRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlStartEvalRunRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlStartEvalRunRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('evalRunStartPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('evalRunStartPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlStartEvalRunRequest' is not null or undefined
            assertParamExists('evalRunStartPost', 'dzlStartEvalRunRequest', dzlStartEvalRunRequest);
            const localVarPath = `/api/dazzle/eval/run/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlStartEvalRunRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get important people.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faceGetImportantPeoplePost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('faceGetImportantPeoplePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('faceGetImportantPeoplePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('faceGetImportantPeoplePost', 'body', body);
            const localVarPath = `/api/dazzle/face/get-important-people`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all photos for a specific person.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetPersonPhotosRequest} getPersonPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faceGetPersonPhotosPost: (xUserAgent_1, xDeviceID_1, getPersonPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getPersonPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getPersonPhotosRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('faceGetPersonPhotosPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('faceGetPersonPhotosPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getPersonPhotosRequest' is not null or undefined
            assertParamExists('faceGetPersonPhotosPost', 'getPersonPhotosRequest', getPersonPhotosRequest);
            const localVarPath = `/api/dazzle/face/get-person-photos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getPersonPhotosRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Submit feedback for an LLM-produced item.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SubmitFeedbackRequest} submitFeedbackRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackSubmitPost: (xUserAgent_1, xDeviceID_1, submitFeedbackRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, submitFeedbackRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, submitFeedbackRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('feedbackSubmitPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('feedbackSubmitPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'submitFeedbackRequest' is not null or undefined
            assertParamExists('feedbackSubmitPost', 'submitFeedbackRequest', submitFeedbackRequest);
            const localVarPath = `/api/dazzle/feedback/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(submitFeedbackRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Health check endpoint for deployment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get profile insights for the current user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetInsightsRequest} getInsightsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightGetInsightsPost: (xUserAgent_1, xDeviceID_1, getInsightsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getInsightsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getInsightsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('insightGetInsightsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('insightGetInsightsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getInsightsRequest' is not null or undefined
            assertParamExists('insightGetInsightsPost', 'getInsightsRequest', getInsightsRequest);
            const localVarPath = `/api/dazzle/insight/get-insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getInsightsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Mark insights as dismissed for the current user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {MarkInsightsDismissedRequest} markInsightsDismissedRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightMarkInsightsDismissedPost: (xUserAgent_1, xDeviceID_1, markInsightsDismissedRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, markInsightsDismissedRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, markInsightsDismissedRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('insightMarkInsightsDismissedPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('insightMarkInsightsDismissedPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'markInsightsDismissedRequest' is not null or undefined
            assertParamExists('insightMarkInsightsDismissedPost', 'markInsightsDismissedRequest', markInsightsDismissedRequest);
            const localVarPath = `/api/dazzle/insight/mark-insights-dismissed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(markInsightsDismissedRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListMcpAgentsRequest} listMcpAgentsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAgentListPost: (xUserAgent_1, xDeviceID_1, listMcpAgentsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, listMcpAgentsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, listMcpAgentsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('mcpAgentListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('mcpAgentListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'listMcpAgentsRequest' is not null or undefined
            assertParamExists('mcpAgentListPost', 'listMcpAgentsRequest', listMcpAgentsRequest);
            const localVarPath = `/api/dazzle/mcp-agent/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listMcpAgentsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {RevokeMcpAgentRequest} revokeMcpAgentRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAgentRevokePost: (xUserAgent_1, xDeviceID_1, revokeMcpAgentRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, revokeMcpAgentRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, revokeMcpAgentRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('mcpAgentRevokePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('mcpAgentRevokePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'revokeMcpAgentRequest' is not null or undefined
            assertParamExists('mcpAgentRevokePost', 'revokeMcpAgentRequest', revokeMcpAgentRequest);
            const localVarPath = `/api/dazzle/mcp-agent/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(revokeMcpAgentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary JSON-RPC transport for /apps/<client_id>.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdPost: (clientId_1, ...args_1) => __awaiter(this, [clientId_1, ...args_1], void 0, function* (clientId, options = {}) {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('mcpAppsStringClientIdPost', 'clientId', clientId);
            const localVarPath = `/apps/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary RFC 7591 dynamic client registration. Returns the pre-seeded client_id.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdRegisterPost: (clientId_1, ...args_1) => __awaiter(this, [clientId_1, ...args_1], void 0, function* (clientId, options = {}) {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('mcpAppsStringClientIdRegisterPost', 'clientId', clientId);
            const localVarPath = `/apps/{client_id}/register`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary RFC 6749 token endpoint scoped to <client_id>; mints with per-client iss.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdTokenPost: (clientId_1, ...args_1) => __awaiter(this, [clientId_1, ...args_1], void 0, function* (clientId, options = {}) {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('mcpAppsStringClientIdTokenPost', 'clientId', clientId);
            const localVarPath = `/apps/{client_id}/token`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Handle MCP JSON-RPC requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/mcp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetMcpTraceRequest} getMcpTraceRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpTraceGetPost: (xUserAgent_1, xDeviceID_1, getMcpTraceRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getMcpTraceRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getMcpTraceRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('mcpTraceGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('mcpTraceGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getMcpTraceRequest' is not null or undefined
            assertParamExists('mcpTraceGetPost', 'getMcpTraceRequest', getMcpTraceRequest);
            const localVarPath = `/api/dazzle/mcp-trace/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getMcpTraceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Page through MCP traces for a user, newest first.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListMcpTracesRequest} listMcpTracesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpTraceListPost: (xUserAgent_1, xDeviceID_1, listMcpTracesRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, listMcpTracesRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, listMcpTracesRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('mcpTraceListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('mcpTraceListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'listMcpTracesRequest' is not null or undefined
            assertParamExists('mcpTraceListPost', 'listMcpTracesRequest', listMcpTracesRequest);
            const localVarPath = `/api/dazzle/mcp-trace/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listMcpTracesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary RFC 8414 Authorization Server Metadata for /apps/<client_id>.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthAuthorizationServerAppsStringClientIdGet: (clientId_1, ...args_1) => __awaiter(this, [clientId_1, ...args_1], void 0, function* (clientId, options = {}) {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('mcpWellknownOauthAuthorizationServerAppsStringClientIdGet', 'clientId', clientId);
            const localVarPath = `/.well-known/oauth-authorization-server/apps/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary RFC 9728 Protected Resource Metadata for /apps/<client_id>.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthProtectedResourceAppsStringClientIdGet: (clientId_1, ...args_1) => __awaiter(this, [clientId_1, ...args_1], void 0, function* (clientId, options = {}) {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('mcpWellknownOauthProtectedResourceAppsStringClientIdGet', 'clientId', clientId);
            const localVarPath = `/.well-known/oauth-protected-resource/apps/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary RFC 9728 Protected Resource Metadata for the MCP endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthProtectedResourceGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/.well-known/oauth-protected-resource`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * <br/>OpenAI supplies the token at directory-submission time; it is stored per environment in<br/>config (`OpenAiAppsChallenge`). Returns 404 until configured, so the route is inert<br/>before submission and never leaks a placeholder.
         * @summary Serve the OpenAI ChatGPT Apps domain-verification token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOpenaiAppsChallengeGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/.well-known/openai-apps-challenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Detailed monitoring endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCheckMonitorGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/monitor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2AuthorizeGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/oauth2/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2DeviceAuthorizationPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/oauth2/device_authorization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {AuthorizeInternalRequest} authorizeInternalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalAuthorizePost: (authorizeInternalRequest_1, ...args_1) => __awaiter(this, [authorizeInternalRequest_1, ...args_1], void 0, function* (authorizeInternalRequest, options = {}) {
            // verify required parameter 'authorizeInternalRequest' is not null or undefined
            assertParamExists('oauth2InternalAuthorizePost', 'authorizeInternalRequest', authorizeInternalRequest);
            const localVarPath = `/api/dazzle/oauth2/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalClientsStringClientIdGet: (clientId_1, ...args_1) => __awaiter(this, [clientId_1, ...args_1], void 0, function* (clientId, options = {}) {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('oauth2InternalClientsStringClientIdGet', 'clientId', clientId);
            const localVarPath = `/api/dazzle/oauth2/clients/{client_id}`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DeviceApproveRequest} deviceApproveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceApprovePost: (deviceApproveRequest_1, ...args_1) => __awaiter(this, [deviceApproveRequest_1, ...args_1], void 0, function* (deviceApproveRequest, options = {}) {
            // verify required parameter 'deviceApproveRequest' is not null or undefined
            assertParamExists('oauth2InternalDeviceApprovePost', 'deviceApproveRequest', deviceApproveRequest);
            const localVarPath = `/api/dazzle/oauth2/device/approve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deviceApproveRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DeviceApproveRequest} deviceApproveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceDenyPost: (deviceApproveRequest_1, ...args_1) => __awaiter(this, [deviceApproveRequest_1, ...args_1], void 0, function* (deviceApproveRequest, options = {}) {
            // verify required parameter 'deviceApproveRequest' is not null or undefined
            assertParamExists('oauth2InternalDeviceDenyPost', 'deviceApproveRequest', deviceApproveRequest);
            const localVarPath = `/api/dazzle/oauth2/device/deny`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deviceApproveRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {DeviceVerifyRequest} deviceVerifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceVerifyPost: (deviceVerifyRequest_1, ...args_1) => __awaiter(this, [deviceVerifyRequest_1, ...args_1], void 0, function* (deviceVerifyRequest, options = {}) {
            // verify required parameter 'deviceVerifyRequest' is not null or undefined
            assertParamExists('oauth2InternalDeviceVerifyPost', 'deviceVerifyRequest', deviceVerifyRequest);
            const localVarPath = `/api/dazzle/oauth2/device/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deviceVerifyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2JwksGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/oauth2/jwks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2RevokePost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/oauth2/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2TokenPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/oauth2/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get onboarding events with computed latencies for a user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetOnboardingEventsInternalRequest} getOnboardingEventsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingGetEventsInternalPost: (xUserAgent_1, xDeviceID_1, getOnboardingEventsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getOnboardingEventsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getOnboardingEventsInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('onboardingGetEventsInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('onboardingGetEventsInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getOnboardingEventsInternalRequest' is not null or undefined
            assertParamExists('onboardingGetEventsInternalPost', 'getOnboardingEventsInternalRequest', getOnboardingEventsInternalRequest);
            const localVarPath = `/api/dazzle/onboarding/get-events-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getOnboardingEventsInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Record an onboarding event for the current user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {RecordOnboardingEventRequest} recordOnboardingEventRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingRecordEventPost: (xUserAgent_1, xDeviceID_1, recordOnboardingEventRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, recordOnboardingEventRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, recordOnboardingEventRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('onboardingRecordEventPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('onboardingRecordEventPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'recordOnboardingEventRequest' is not null or undefined
            assertParamExists('onboardingRecordEventPost', 'recordOnboardingEventRequest', recordOnboardingEventRequest);
            const localVarPath = `/api/dazzle/onboarding/record-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recordOnboardingEventRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Assign order to fulfiller.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlAssignOrderRequest} dzlAssignOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAssignPost: (xUserAgent_1, xDeviceID_1, dzlAssignOrderRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlAssignOrderRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlAssignOrderRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderAssignPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderAssignPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlAssignOrderRequest' is not null or undefined
            assertParamExists('orderAssignPost', 'dzlAssignOrderRequest', dzlAssignOrderRequest);
            const localVarPath = `/api/dazzle/order/assign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlAssignOrderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Mark order as complete.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlOrderCompleteRequest} dzlOrderCompleteRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCompletePost: (xUserAgent_1, xDeviceID_1, dzlOrderCompleteRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlOrderCompleteRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlOrderCompleteRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderCompletePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderCompletePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlOrderCompleteRequest' is not null or undefined
            assertParamExists('orderCompletePost', 'dzlOrderCompleteRequest', dzlOrderCompleteRequest);
            const localVarPath = `/api/dazzle/order/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlOrderCompleteRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create an order from a suggestion.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreateDzlOrderFromSuggestionRequest} createDzlOrderFromSuggestionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateFromSuggestionPost: (xUserAgent_1, xDeviceID_1, createDzlOrderFromSuggestionRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, createDzlOrderFromSuggestionRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, createDzlOrderFromSuggestionRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderCreateFromSuggestionPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderCreateFromSuggestionPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'createDzlOrderFromSuggestionRequest' is not null or undefined
            assertParamExists('orderCreateFromSuggestionPost', 'createDzlOrderFromSuggestionRequest', createDzlOrderFromSuggestionRequest);
            const localVarPath = `/api/dazzle/order/create-from-suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createDzlOrderFromSuggestionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlCreateOrderInternalRequest} dzlCreateOrderInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateInternalPost: (xUserAgent_1, xDeviceID_1, dzlCreateOrderInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlCreateOrderInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlCreateOrderInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderCreateInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderCreateInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlCreateOrderInternalRequest' is not null or undefined
            assertParamExists('orderCreateInternalPost', 'dzlCreateOrderInternalRequest', dzlCreateOrderInternalRequest);
            const localVarPath = `/api/dazzle/order/create-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlCreateOrderInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlDeleteOrderInternalRequest} dzlDeleteOrderInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDeleteInternalPost: (xUserAgent_1, xDeviceID_1, dzlDeleteOrderInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlDeleteOrderInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlDeleteOrderInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderDeleteInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderDeleteInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlDeleteOrderInternalRequest' is not null or undefined
            assertParamExists('orderDeleteInternalPost', 'dzlDeleteOrderInternalRequest', dzlDeleteOrderInternalRequest);
            const localVarPath = `/api/dazzle/order/delete-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlDeleteOrderInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get single order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDzlOrderRequest} getDzlOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetPost: (xUserAgent_1, xDeviceID_1, getDzlOrderRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getDzlOrderRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getDzlOrderRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getDzlOrderRequest' is not null or undefined
            assertParamExists('orderGetPost', 'getDzlOrderRequest', getDzlOrderRequest);
            const localVarPath = `/api/dazzle/order/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getDzlOrderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all orders.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllDzlOrdersRequest} getAllDzlOrdersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderListPost: (xUserAgent_1, xDeviceID_1, getAllDzlOrdersRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getAllDzlOrdersRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getAllDzlOrdersRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getAllDzlOrdersRequest' is not null or undefined
            assertParamExists('orderListPost', 'getAllDzlOrdersRequest', getAllDzlOrdersRequest);
            const localVarPath = `/api/dazzle/order/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAllDzlOrdersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Process order payment.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlOrderPaymentRequest} dzlOrderPaymentRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPaymentPost: (xUserAgent_1, xDeviceID_1, dzlOrderPaymentRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlOrderPaymentRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlOrderPaymentRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderPaymentPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderPaymentPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlOrderPaymentRequest' is not null or undefined
            assertParamExists('orderPaymentPost', 'dzlOrderPaymentRequest', dzlOrderPaymentRequest);
            const localVarPath = `/api/dazzle/order/payment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlOrderPaymentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Place a new order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {PlaceDzlOrderRequest} placeDzlOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPlacePost: (xUserAgent_1, xDeviceID_1, placeDzlOrderRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, placeDzlOrderRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, placeDzlOrderRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderPlacePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderPlacePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'placeDzlOrderRequest' is not null or undefined
            assertParamExists('orderPlacePost', 'placeDzlOrderRequest', placeDzlOrderRequest);
            const localVarPath = `/api/dazzle/order/place`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(placeDzlOrderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send payment link to user via iMessage.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendPaymentLinkRequest} sendPaymentLinkRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSendPaymentLinkPost: (xUserAgent_1, xDeviceID_1, sendPaymentLinkRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, sendPaymentLinkRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, sendPaymentLinkRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderSendPaymentLinkPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderSendPaymentLinkPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'sendPaymentLinkRequest' is not null or undefined
            assertParamExists('orderSendPaymentLinkPost', 'sendPaymentLinkRequest', sendPaymentLinkRequest);
            const localVarPath = `/api/dazzle/order/send-payment-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendPaymentLinkRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Clear Stripe information for a user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClearDzlStripeRequest} clearDzlStripeRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeClearPost: (xUserAgent_1, xDeviceID_1, clearDzlStripeRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, clearDzlStripeRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, clearDzlStripeRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderStripeClearPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderStripeClearPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'clearDzlStripeRequest' is not null or undefined
            assertParamExists('orderStripeClearPost', 'clearDzlStripeRequest', clearDzlStripeRequest);
            const localVarPath = `/api/dazzle/order/stripe/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(clearDzlStripeRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Confirm Stripe setup intent.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ConfirmDzlStripeSetupIntentRequest} confirmDzlStripeSetupIntentRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeConfirmSetupPost: (xUserAgent_1, xDeviceID_1, confirmDzlStripeSetupIntentRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, confirmDzlStripeSetupIntentRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, confirmDzlStripeSetupIntentRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderStripeConfirmSetupPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderStripeConfirmSetupPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'confirmDzlStripeSetupIntentRequest' is not null or undefined
            assertParamExists('orderStripeConfirmSetupPost', 'confirmDzlStripeSetupIntentRequest', confirmDzlStripeSetupIntentRequest);
            const localVarPath = `/api/dazzle/order/stripe/confirm-setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(confirmDzlStripeSetupIntentRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Stripe setup intent.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeSetupIntentPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderStripeSetupIntentPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderStripeSetupIntentPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('orderStripeSetupIntentPost', 'body', body);
            const localVarPath = `/api/dazzle/order/stripe/setup-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlUpdateOrderRequest} dzlUpdateOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderUpdatePost: (xUserAgent_1, xDeviceID_1, dzlUpdateOrderRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlUpdateOrderRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlUpdateOrderRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('orderUpdatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('orderUpdatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlUpdateOrderRequest' is not null or undefined
            assertParamExists('orderUpdatePost', 'dzlUpdateOrderRequest', dzlUpdateOrderRequest);
            const localVarPath = `/api/dazzle/order/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlUpdateOrderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete photos by local asset IDs.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DeletePhotoRequest} deletePhotoRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoDeletePost: (xUserAgent_1, xDeviceID_1, deletePhotoRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, deletePhotoRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, deletePhotoRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoDeletePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoDeletePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'deletePhotoRequest' is not null or undefined
            assertParamExists('photoDeletePost', 'deletePhotoRequest', deletePhotoRequest);
            const localVarPath = `/api/dazzle/photo/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletePhotoRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Upload photo features/metadata for multiple photos.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UploadPhotoFeaturesRequest} uploadPhotoFeaturesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoFeaturesPost: (xUserAgent_1, xDeviceID_1, uploadPhotoFeaturesRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, uploadPhotoFeaturesRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, uploadPhotoFeaturesRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoFeaturesPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoFeaturesPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'uploadPhotoFeaturesRequest' is not null or undefined
            assertParamExists('photoFeaturesPost', 'uploadPhotoFeaturesRequest', uploadPhotoFeaturesRequest);
            const localVarPath = `/api/dazzle/photo/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(uploadPhotoFeaturesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get photo URLs for asset IDs.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetPhotoUrlsForAssetIdsRequest} getPhotoUrlsForAssetIdsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGetUrlsPost: (xUserAgent_1, xDeviceID_1, getPhotoUrlsForAssetIdsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getPhotoUrlsForAssetIdsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getPhotoUrlsForAssetIdsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoGetUrlsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoGetUrlsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getPhotoUrlsForAssetIdsRequest' is not null or undefined
            assertParamExists('photoGetUrlsPost', 'getPhotoUrlsForAssetIdsRequest', getPhotoUrlsForAssetIdsRequest);
            const localVarPath = `/api/dazzle/photo/get-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getPhotoUrlsForAssetIdsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Accept a photo group with optional custom tags.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AcceptPhotoGroupRequest} acceptPhotoGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupAcceptPost: (xUserAgent_1, xDeviceID_1, acceptPhotoGroupRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, acceptPhotoGroupRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, acceptPhotoGroupRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoGroupAcceptPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoGroupAcceptPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'acceptPhotoGroupRequest' is not null or undefined
            assertParamExists('photoGroupAcceptPost', 'acceptPhotoGroupRequest', acceptPhotoGroupRequest);
            const localVarPath = `/api/dazzle/photo/group/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(acceptPhotoGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a conversation thread from a photo group.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreateThreadFromGroupRequest} createThreadFromGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupCreateThreadPost: (xUserAgent_1, xDeviceID_1, createThreadFromGroupRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, createThreadFromGroupRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, createThreadFromGroupRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoGroupCreateThreadPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoGroupCreateThreadPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'createThreadFromGroupRequest' is not null or undefined
            assertParamExists('photoGroupCreateThreadPost', 'createThreadFromGroupRequest', createThreadFromGroupRequest);
            const localVarPath = `/api/dazzle/photo/group/create-thread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createThreadFromGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Dismiss a photo group.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DismissPhotoGroupRequest} dismissPhotoGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupDismissPost: (xUserAgent_1, xDeviceID_1, dismissPhotoGroupRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dismissPhotoGroupRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dismissPhotoGroupRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoGroupDismissPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoGroupDismissPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dismissPhotoGroupRequest' is not null or undefined
            assertParamExists('photoGroupDismissPost', 'dismissPhotoGroupRequest', dismissPhotoGroupRequest);
            const localVarPath = `/api/dazzle/photo/group/dismiss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dismissPhotoGroupRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Start profile idea generation.
         * @param {GenerateProfileStartRequest} generateProfileStartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupGenerateProfileStartPost: (generateProfileStartRequest_1, ...args_1) => __awaiter(this, [generateProfileStartRequest_1, ...args_1], void 0, function* (generateProfileStartRequest, options = {}) {
            // verify required parameter 'generateProfileStartRequest' is not null or undefined
            assertParamExists('photoGroupGenerateProfileStartPost', 'generateProfileStartRequest', generateProfileStartRequest);
            const localVarPath = `/api/dazzle/photo/group/generate-profile-start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(generateProfileStartRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get photo groups and ideas for a user, with optional S3 URLs.
         * @param {GetUserPhotoGroupsAndIdeasRequest} getUserPhotoGroupsAndIdeasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupGetUserDataPost: (getUserPhotoGroupsAndIdeasRequest_1, ...args_1) => __awaiter(this, [getUserPhotoGroupsAndIdeasRequest_1, ...args_1], void 0, function* (getUserPhotoGroupsAndIdeasRequest, options = {}) {
            // verify required parameter 'getUserPhotoGroupsAndIdeasRequest' is not null or undefined
            assertParamExists('photoGroupGetUserDataPost', 'getUserPhotoGroupsAndIdeasRequest', getUserPhotoGroupsAndIdeasRequest);
            const localVarPath = `/api/dazzle/photo/group/get-user-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUserPhotoGroupsAndIdeasRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List photo groups for the authenticated user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListPhotoGroupsRequest} listPhotoGroupsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupListPost: (xUserAgent_1, xDeviceID_1, listPhotoGroupsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, listPhotoGroupsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, listPhotoGroupsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoGroupListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoGroupListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'listPhotoGroupsRequest' is not null or undefined
            assertParamExists('photoGroupListPost', 'listPhotoGroupsRequest', listPhotoGroupsRequest);
            const localVarPath = `/api/dazzle/photo/group/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listPhotoGroupsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Regenerate photo groups and/or IDEAS for a specific user.
         * @param {RegenerateIdeasRequest} regenerateIdeasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupRegenerateIdeasPost: (regenerateIdeasRequest_1, ...args_1) => __awaiter(this, [regenerateIdeasRequest_1, ...args_1], void 0, function* (regenerateIdeasRequest, options = {}) {
            // verify required parameter 'regenerateIdeasRequest' is not null or undefined
            assertParamExists('photoGroupRegenerateIdeasPost', 'regenerateIdeasRequest', regenerateIdeasRequest);
            const localVarPath = `/api/dazzle/photo/group/regenerate-ideas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(regenerateIdeasRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Start regeneration by marking pending for workers.
         * @param {RegenerateStartRequest} regenerateStartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupRegenerateStartPost: (regenerateStartRequest_1, ...args_1) => __awaiter(this, [regenerateStartRequest_1, ...args_1], void 0, function* (regenerateStartRequest, options = {}) {
            // verify required parameter 'regenerateStartRequest' is not null or undefined
            assertParamExists('photoGroupRegenerateStartPost', 'regenerateStartRequest', regenerateStartRequest);
            const localVarPath = `/api/dazzle/photo/group/regenerate-start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(regenerateStartRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update tags for an existing photo group.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdatePhotoGroupTagsRequest} updatePhotoGroupTagsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupUpdateTagsPost: (xUserAgent_1, xDeviceID_1, updatePhotoGroupTagsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updatePhotoGroupTagsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updatePhotoGroupTagsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoGroupUpdateTagsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoGroupUpdateTagsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updatePhotoGroupTagsRequest' is not null or undefined
            assertParamExists('photoGroupUpdateTagsPost', 'updatePhotoGroupTagsRequest', updatePhotoGroupTagsRequest);
            const localVarPath = `/api/dazzle/photo/group/update-tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhotoGroupTagsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * <br/>Expects multipart/form-data with:<br/>- local_asset_id: The local asset ID<br/>- file: The photo file
         * @summary Upload a photo.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {File} file
         * @param {string} localAssetId
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoUploadPost: (xUserAgent_1, xDeviceID_1, file_1, localAssetId_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, file_1, localAssetId_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, file, localAssetId, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('photoUploadPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('photoUploadPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('photoUploadPost', 'file', file);
            // verify required parameter 'localAssetId' is not null or undefined
            assertParamExists('photoUploadPost', 'localAssetId', localAssetId);
            const localVarPath = `/api/dazzle/photo/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (localAssetId !== undefined) {
                localVarFormParams.append('local_asset_id', localAssetId);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreatePlatformApiKeyRequest} createPlatformApiKeyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyCreatePost: (xUserAgent_1, xDeviceID_1, createPlatformApiKeyRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, createPlatformApiKeyRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, createPlatformApiKeyRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('platformKeyCreatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('platformKeyCreatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'createPlatformApiKeyRequest' is not null or undefined
            assertParamExists('platformKeyCreatePost', 'createPlatformApiKeyRequest', createPlatformApiKeyRequest);
            const localVarPath = `/api/dazzle/platform-key/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPlatformApiKeyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyListPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('platformKeyListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('platformKeyListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('platformKeyListPost', 'body', body);
            const localVarPath = `/api/dazzle/platform-key/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {RevokePlatformApiKeyRequest} revokePlatformApiKeyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyRevokePost: (xUserAgent_1, xDeviceID_1, revokePlatformApiKeyRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, revokePlatformApiKeyRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, revokePlatformApiKeyRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('platformKeyRevokePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('platformKeyRevokePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'revokePlatformApiKeyRequest' is not null or undefined
            assertParamExists('platformKeyRevokePost', 'revokePlatformApiKeyRequest', revokePlatformApiKeyRequest);
            const localVarPath = `/api/dazzle/platform-key/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(revokePlatformApiKeyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdatePlatformApiKeyRequest} updatePlatformApiKeyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyUpdatePost: (xUserAgent_1, xDeviceID_1, updatePlatformApiKeyRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updatePlatformApiKeyRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updatePlatformApiKeyRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('platformKeyUpdatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('platformKeyUpdatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updatePlatformApiKeyRequest' is not null or undefined
            assertParamExists('platformKeyUpdatePost', 'updatePlatformApiKeyRequest', updatePlatformApiKeyRequest);
            const localVarPath = `/api/dazzle/platform-key/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlatformApiKeyRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabProcessChatRequest} profileLabProcessChatRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabChatProcessPost: (xUserAgent_1, xDeviceID_1, profileLabProcessChatRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabProcessChatRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabProcessChatRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabChatProcessPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabChatProcessPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabProcessChatRequest' is not null or undefined
            assertParamExists('profileLabChatProcessPost', 'profileLabProcessChatRequest', profileLabProcessChatRequest);
            const localVarPath = `/api/dazzle/profile-lab/chat/process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabProcessChatRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabExportDatasetRequest} profileLabExportDatasetRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabDatasetExportPost: (xUserAgent_1, xDeviceID_1, profileLabExportDatasetRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabExportDatasetRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabExportDatasetRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabDatasetExportPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabDatasetExportPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabExportDatasetRequest' is not null or undefined
            assertParamExists('profileLabDatasetExportPost', 'profileLabExportDatasetRequest', profileLabExportDatasetRequest);
            const localVarPath = `/api/dazzle/profile-lab/dataset/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabExportDatasetRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabListPeopleRequest} profileLabListPeopleRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPeopleListPost: (xUserAgent_1, xDeviceID_1, profileLabListPeopleRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabListPeopleRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabListPeopleRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabPeopleListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabPeopleListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabListPeopleRequest' is not null or undefined
            assertParamExists('profileLabPeopleListPost', 'profileLabListPeopleRequest', profileLabListPeopleRequest);
            const localVarPath = `/api/dazzle/profile-lab/people/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabListPeopleRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabGetPersonPhotosRequest} profileLabGetPersonPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPeoplePhotosPost: (xUserAgent_1, xDeviceID_1, profileLabGetPersonPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabGetPersonPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabGetPersonPhotosRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabPeoplePhotosPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabPeoplePhotosPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabGetPersonPhotosRequest' is not null or undefined
            assertParamExists('profileLabPeoplePhotosPost', 'profileLabGetPersonPhotosRequest', profileLabGetPersonPhotosRequest);
            const localVarPath = `/api/dazzle/profile-lab/people/photos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabGetPersonPhotosRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabListPhotosRequest} profileLabListPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPhotosListPost: (xUserAgent_1, xDeviceID_1, profileLabListPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabListPhotosRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabListPhotosRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabPhotosListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabPhotosListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabListPhotosRequest' is not null or undefined
            assertParamExists('profileLabPhotosListPost', 'profileLabListPhotosRequest', profileLabListPhotosRequest);
            const localVarPath = `/api/dazzle/profile-lab/photos/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabListPhotosRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabGetSignedUrlsRequest} profileLabGetSignedUrlsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPhotosSignedUrlsPost: (xUserAgent_1, xDeviceID_1, profileLabGetSignedUrlsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabGetSignedUrlsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabGetSignedUrlsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabPhotosSignedUrlsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabPhotosSignedUrlsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabGetSignedUrlsRequest' is not null or undefined
            assertParamExists('profileLabPhotosSignedUrlsPost', 'profileLabGetSignedUrlsRequest', profileLabGetSignedUrlsRequest);
            const localVarPath = `/api/dazzle/profile-lab/photos/signed-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabGetSignedUrlsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabComputeSelectionRequest} profileLabComputeSelectionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabSelectionComputePost: (xUserAgent_1, xDeviceID_1, profileLabComputeSelectionRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabComputeSelectionRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabComputeSelectionRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabSelectionComputePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabSelectionComputePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabComputeSelectionRequest' is not null or undefined
            assertParamExists('profileLabSelectionComputePost', 'profileLabComputeSelectionRequest', profileLabComputeSelectionRequest);
            const localVarPath = `/api/dazzle/profile-lab/selection/compute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabComputeSelectionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabRunStageRequest} profileLabRunStageRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagePreviewPost: (xUserAgent_1, xDeviceID_1, profileLabRunStageRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabRunStageRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabRunStageRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabStagePreviewPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabStagePreviewPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabRunStageRequest' is not null or undefined
            assertParamExists('profileLabStagePreviewPost', 'profileLabRunStageRequest', profileLabRunStageRequest);
            const localVarPath = `/api/dazzle/profile-lab/stage/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabRunStageRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {number} userLid
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageResultGet: (xUserAgent_1, xDeviceID_1, userLid_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, userLid_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, userLid, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabStageResultGet', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabStageResultGet', 'xDeviceID', xDeviceID);
            // verify required parameter 'userLid' is not null or undefined
            assertParamExists('profileLabStageResultGet', 'userLid', userLid);
            const localVarPath = `/api/dazzle/profile-lab/stage/result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (userLid !== undefined) {
                localVarQueryParameter['user_lid'] = userLid;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabRunStageRequest} profileLabRunStageRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageRunPost: (xUserAgent_1, xDeviceID_1, profileLabRunStageRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabRunStageRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabRunStageRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabStageRunPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabStageRunPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabRunStageRequest' is not null or undefined
            assertParamExists('profileLabStageRunPost', 'profileLabRunStageRequest', profileLabRunStageRequest);
            const localVarPath = `/api/dazzle/profile-lab/stage/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabRunStageRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {number} userLid
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageStatusGet: (xUserAgent_1, xDeviceID_1, userLid_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, userLid_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, userLid, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabStageStatusGet', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabStageStatusGet', 'xDeviceID', xDeviceID);
            // verify required parameter 'userLid' is not null or undefined
            assertParamExists('profileLabStageStatusGet', 'userLid', userLid);
            const localVarPath = `/api/dazzle/profile-lab/stage/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (userLid !== undefined) {
                localVarQueryParameter['user_lid'] = userLid;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabGetStageDefinitionRequest} profileLabGetStageDefinitionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagesDefinitionPost: (xUserAgent_1, xDeviceID_1, profileLabGetStageDefinitionRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, profileLabGetStageDefinitionRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, profileLabGetStageDefinitionRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabStagesDefinitionPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabStagesDefinitionPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'profileLabGetStageDefinitionRequest' is not null or undefined
            assertParamExists('profileLabStagesDefinitionPost', 'profileLabGetStageDefinitionRequest', profileLabGetStageDefinitionRequest);
            const localVarPath = `/api/dazzle/profile-lab/stages/definition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profileLabGetStageDefinitionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagesListPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('profileLabStagesListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('profileLabStagesListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('profileLabStagesListPost', 'body', body);
            const localVarPath = `/api/dazzle/profile-lab/stages/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Fetch prompts by type.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlFetchPromptsRequest} dzlFetchPromptsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptFetchPost: (xUserAgent_1, xDeviceID_1, dzlFetchPromptsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlFetchPromptsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlFetchPromptsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('promptFetchPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('promptFetchPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlFetchPromptsRequest' is not null or undefined
            assertParamExists('promptFetchPost', 'dzlFetchPromptsRequest', dzlFetchPromptsRequest);
            const localVarPath = `/api/dazzle/prompt/fetch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlFetchPromptsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update prompt text.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlUpdatePromptRequest} dzlUpdatePromptRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptUpdatePost: (xUserAgent_1, xDeviceID_1, dzlUpdatePromptRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, dzlUpdatePromptRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, dzlUpdatePromptRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('promptUpdatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('promptUpdatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'dzlUpdatePromptRequest' is not null or undefined
            assertParamExists('promptUpdatePost', 'dzlUpdatePromptRequest', dzlUpdatePromptRequest);
            const localVarPath = `/api/dazzle/prompt/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(dzlUpdatePromptRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add a new reminder.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AddDzlReminderRequest} addDzlReminderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderAddPost: (xUserAgent_1, xDeviceID_1, addDzlReminderRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, addDzlReminderRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, addDzlReminderRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('reminderAddPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('reminderAddPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'addDzlReminderRequest' is not null or undefined
            assertParamExists('reminderAddPost', 'addDzlReminderRequest', addDzlReminderRequest);
            const localVarPath = `/api/dazzle/reminder/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(addDzlReminderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all reminders.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllDzlRemindersRequest} getAllDzlRemindersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderListPost: (xUserAgent_1, xDeviceID_1, getAllDzlRemindersRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getAllDzlRemindersRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getAllDzlRemindersRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('reminderListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('reminderListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getAllDzlRemindersRequest' is not null or undefined
            assertParamExists('reminderListPost', 'getAllDzlRemindersRequest', getAllDzlRemindersRequest);
            const localVarPath = `/api/dazzle/reminder/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAllDzlRemindersRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Schedule a reminder notification.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ScheduleReminderNotificationRequest} scheduleReminderNotificationRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderScheduleNotificationPost: (xUserAgent_1, xDeviceID_1, scheduleReminderNotificationRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, scheduleReminderNotificationRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, scheduleReminderNotificationRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('reminderScheduleNotificationPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('reminderScheduleNotificationPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'scheduleReminderNotificationRequest' is not null or undefined
            assertParamExists('reminderScheduleNotificationPost', 'scheduleReminderNotificationRequest', scheduleReminderNotificationRequest);
            const localVarPath = `/api/dazzle/reminder/schedule-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleReminderNotificationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update reminder status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlReminderStatusRequest} updateDzlReminderStatusRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderUpdateStatusPost: (xUserAgent_1, xDeviceID_1, updateDzlReminderStatusRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlReminderStatusRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlReminderStatusRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('reminderUpdateStatusPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('reminderUpdateStatusPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlReminderStatusRequest' is not null or undefined
            assertParamExists('reminderUpdateStatusPost', 'updateDzlReminderStatusRequest', updateDzlReminderStatusRequest);
            const localVarPath = `/api/dazzle/reminder/update-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlReminderStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {FeatureFlagCommandRequest} featureFlagCommandRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagCommandPost: (xUserAgent_1, xDeviceID_1, featureFlagCommandRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, featureFlagCommandRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, featureFlagCommandRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('revereFeatureFlagCommandPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('revereFeatureFlagCommandPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'featureFlagCommandRequest' is not null or undefined
            assertParamExists('revereFeatureFlagCommandPost', 'featureFlagCommandRequest', featureFlagCommandRequest);
            const localVarPath = `/api/dazzle/revere/feature-flag/command`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(featureFlagCommandRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagNamesPost: (xUserAgent_1, xDeviceID_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('revereFeatureFlagNamesPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('revereFeatureFlagNamesPost', 'xDeviceID', xDeviceID);
            const localVarPath = `/api/dazzle/revere/feature-flag/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetFeatureFlagStateRequest} getFeatureFlagStateRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagStatePost: (xUserAgent_1, xDeviceID_1, getFeatureFlagStateRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getFeatureFlagStateRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getFeatureFlagStateRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('revereFeatureFlagStatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('revereFeatureFlagStatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getFeatureFlagStateRequest' is not null or undefined
            assertParamExists('revereFeatureFlagStatePost', 'getFeatureFlagStateRequest', getFeatureFlagStateRequest);
            const localVarPath = `/api/dazzle/revere/feature-flag/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getFeatureFlagStateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {TimerTaskCommandRequest} timerTaskCommandRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskCommandPost: (xUserAgent_1, xDeviceID_1, timerTaskCommandRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, timerTaskCommandRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, timerTaskCommandRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('revereTimerTaskCommandPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('revereTimerTaskCommandPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'timerTaskCommandRequest' is not null or undefined
            assertParamExists('revereTimerTaskCommandPost', 'timerTaskCommandRequest', timerTaskCommandRequest);
            const localVarPath = `/api/dazzle/revere/timer-task/command`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(timerTaskCommandRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskNamesPost: (xUserAgent_1, xDeviceID_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('revereTimerTaskNamesPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('revereTimerTaskNamesPost', 'xDeviceID', xDeviceID);
            const localVarPath = `/api/dazzle/revere/timer-task/names`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetTimerTaskStateRequest} getTimerTaskStateRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskStatePost: (xUserAgent_1, xDeviceID_1, getTimerTaskStateRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getTimerTaskStateRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getTimerTaskStateRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('revereTimerTaskStatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('revereTimerTaskStatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getTimerTaskStateRequest' is not null or undefined
            assertParamExists('revereTimerTaskStatePost', 'getTimerTaskStateRequest', getTimerTaskStateRequest);
            const localVarPath = `/api/dazzle/revere/timer-task/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getTimerTaskStateRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Receive webhook events from SendBlue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendblueWebhookWebhookPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/api/dazzle/sendblue/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get an access token from a Google OAuth refresh token in the cookie
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionRefreshAccessTokenPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('sessionRefreshAccessTokenPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('sessionRefreshAccessTokenPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sessionRefreshAccessTokenPost', 'body', body);
            const localVarPath = `/api/dazzle/session/refresh-access-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set a Google OAuth refresh token used in internal apps to a cookie
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SetRefreshTokenRequest} setRefreshTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionSetRefreshTokenPost: (xUserAgent_1, xDeviceID_1, setRefreshTokenRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, setRefreshTokenRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, setRefreshTokenRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('sessionSetRefreshTokenPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('sessionSetRefreshTokenPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'setRefreshTokenRequest' is not null or undefined
            assertParamExists('sessionSetRefreshTokenPost', 'setRefreshTokenRequest', setRefreshTokenRequest);
            const localVarPath = `/api/dazzle/session/set-refresh-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setRefreshTokenRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Receive webhook events from Twilio shortcode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortcodeWebhookWebhookPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/api/dazzle/shortcode/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get deduped suggestions for user (internal endpoint).
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDedupedSuggestionsInternalRequest} getDedupedSuggestionsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetDedupedSuggestionsInternalPost: (xUserAgent_1, xDeviceID_1, getDedupedSuggestionsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getDedupedSuggestionsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getDedupedSuggestionsInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetDedupedSuggestionsInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetDedupedSuggestionsInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getDedupedSuggestionsInternalRequest' is not null or undefined
            assertParamExists('suggestionGetDedupedSuggestionsInternalPost', 'getDedupedSuggestionsInternalRequest', getDedupedSuggestionsInternalRequest);
            const localVarPath = `/api/dazzle/suggestion/get-deduped-suggestions-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getDedupedSuggestionsInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get reviewable suggestions with pagination.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetSuggestionInternalRequest} getSuggestionInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetInternalPost: (xUserAgent_1, xDeviceID_1, getSuggestionInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getSuggestionInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getSuggestionInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getSuggestionInternalRequest' is not null or undefined
            assertParamExists('suggestionGetInternalPost', 'getSuggestionInternalRequest', getSuggestionInternalRequest);
            const localVarPath = `/api/dazzle/suggestion/get-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getSuggestionInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get pending suggestions.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetPendingDzlSuggestionsRequest} getPendingDzlSuggestionsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetPendingPost: (xUserAgent_1, xDeviceID_1, getPendingDzlSuggestionsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getPendingDzlSuggestionsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getPendingDzlSuggestionsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetPendingPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetPendingPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getPendingDzlSuggestionsRequest' is not null or undefined
            assertParamExists('suggestionGetPendingPost', 'getPendingDzlSuggestionsRequest', getPendingDzlSuggestionsRequest);
            const localVarPath = `/api/dazzle/suggestion/get-pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getPendingDzlSuggestionsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a single suggestion by ID.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetSuggestionRequest} getSuggestionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetPost: (xUserAgent_1, xDeviceID_1, getSuggestionRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getSuggestionRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getSuggestionRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getSuggestionRequest' is not null or undefined
            assertParamExists('suggestionGetPost', 'getSuggestionRequest', getSuggestionRequest);
            const localVarPath = `/api/dazzle/suggestion/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getSuggestionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get global quality feedback statistics.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetQualityFeedbackStatsInternalRequest} getQualityFeedbackStatsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetQualityFeedbackStatsInternalPost: (xUserAgent_1, xDeviceID_1, getQualityFeedbackStatsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getQualityFeedbackStatsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getQualityFeedbackStatsInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetQualityFeedbackStatsInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetQualityFeedbackStatsInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getQualityFeedbackStatsInternalRequest' is not null or undefined
            assertParamExists('suggestionGetQualityFeedbackStatsInternalPost', 'getQualityFeedbackStatsInternalRequest', getQualityFeedbackStatsInternalRequest);
            const localVarPath = `/api/dazzle/suggestion/get-quality-feedback-stats-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getQualityFeedbackStatsInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get reviewable suggestions with pagination.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetReviewableSuggestionsInternalRequest} getReviewableSuggestionsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetReviewableInternalPost: (xUserAgent_1, xDeviceID_1, getReviewableSuggestionsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getReviewableSuggestionsInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getReviewableSuggestionsInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetReviewableInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetReviewableInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getReviewableSuggestionsInternalRequest' is not null or undefined
            assertParamExists('suggestionGetReviewableInternalPost', 'getReviewableSuggestionsInternalRequest', getReviewableSuggestionsInternalRequest);
            const localVarPath = `/api/dazzle/suggestion/get-reviewable-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getReviewableSuggestionsInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get suggestions with pagination and optional uniform per-type limit.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetSuggestionsRequest} getSuggestionsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetSuggestionsPost: (xUserAgent_1, xDeviceID_1, getSuggestionsRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getSuggestionsRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getSuggestionsRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionGetSuggestionsPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionGetSuggestionsPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getSuggestionsRequest' is not null or undefined
            assertParamExists('suggestionGetSuggestionsPost', 'getSuggestionsRequest', getSuggestionsRequest);
            const localVarPath = `/api/dazzle/suggestion/get-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getSuggestionsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Materialize a quick suggestion by persisting photo and suggestion to storage.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {File} file
         * @param {string} localAssetId
         * @param {Suggestion} suggestionData
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionQuickSuggestionMaterializePost: (xUserAgent_1, xDeviceID_1, file_1, localAssetId_1, suggestionData_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, file_1, localAssetId_1, suggestionData_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, file, localAssetId, suggestionData, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionQuickSuggestionMaterializePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionQuickSuggestionMaterializePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('suggestionQuickSuggestionMaterializePost', 'file', file);
            // verify required parameter 'localAssetId' is not null or undefined
            assertParamExists('suggestionQuickSuggestionMaterializePost', 'localAssetId', localAssetId);
            // verify required parameter 'suggestionData' is not null or undefined
            assertParamExists('suggestionQuickSuggestionMaterializePost', 'suggestionData', suggestionData);
            const localVarPath = `/api/dazzle/suggestion/quick-suggestion/materialize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (localAssetId !== undefined) {
                localVarFormParams.append('local_asset_id', localAssetId);
            }
            if (suggestionData !== undefined) {
                localVarFormParams.append('suggestion_data', new Blob([JSON.stringify(suggestionData, replaceWithSerializableTypeIfNeeded)], { type: "application/json", }));
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a quick suggestion from an image.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {File} file
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {string | null} [localAssetId]
         * @param {string | null} [model]
         * @param {string | null} [photoTs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionQuickSuggestionPost: (xUserAgent_1, xDeviceID_1, file_1, xReqID_1, xRequestID_1, localAssetId_1, model_1, photoTs_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, file_1, xReqID_1, xRequestID_1, localAssetId_1, model_1, photoTs_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, file, xReqID, xRequestID, localAssetId, model, photoTs, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionQuickSuggestionPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionQuickSuggestionPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'file' is not null or undefined
            assertParamExists('suggestionQuickSuggestionPost', 'file', file);
            const localVarPath = `/api/dazzle/suggestion/quick-suggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            if (localAssetId !== undefined) {
                localVarFormParams.append('local_asset_id', localAssetId);
            }
            if (model !== undefined) {
                localVarFormParams.append('model', model);
            }
            if (photoTs !== undefined) {
                localVarFormParams.append('photo_ts', photoTs);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send transcription email.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendDzlTranscriptionEmailRequest} sendDzlTranscriptionEmailRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionSendEmailPost: (xUserAgent_1, xDeviceID_1, sendDzlTranscriptionEmailRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, sendDzlTranscriptionEmailRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, sendDzlTranscriptionEmailRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionSendEmailPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionSendEmailPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'sendDzlTranscriptionEmailRequest' is not null or undefined
            assertParamExists('suggestionSendEmailPost', 'sendDzlTranscriptionEmailRequest', sendDzlTranscriptionEmailRequest);
            const localVarPath = `/api/dazzle/suggestion/send-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendDzlTranscriptionEmailRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Start a conversation from a suggestion.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {StartConversationFromSuggestionRequest} startConversationFromSuggestionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionStartConversationPost: (xUserAgent_1, xDeviceID_1, startConversationFromSuggestionRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, startConversationFromSuggestionRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, startConversationFromSuggestionRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionStartConversationPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionStartConversationPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'startConversationFromSuggestionRequest' is not null or undefined
            assertParamExists('suggestionStartConversationPost', 'startConversationFromSuggestionRequest', startConversationFromSuggestionRequest);
            const localVarPath = `/api/dazzle/suggestion/start-conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(startConversationFromSuggestionRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update suggestions status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionInternalRequest} updateDzlSuggestionInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateInternalPost: (xUserAgent_1, xDeviceID_1, updateDzlSuggestionInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlSuggestionInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlSuggestionInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionUpdateInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionUpdateInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlSuggestionInternalRequest' is not null or undefined
            assertParamExists('suggestionUpdateInternalPost', 'updateDzlSuggestionInternalRequest', updateDzlSuggestionInternalRequest);
            const localVarPath = `/api/dazzle/suggestion/update-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlSuggestionInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update suggestion quality feedback.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionQualityFeedbackRequest} updateDzlSuggestionQualityFeedbackRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateQualityFeedbackPost: (xUserAgent_1, xDeviceID_1, updateDzlSuggestionQualityFeedbackRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlSuggestionQualityFeedbackRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlSuggestionQualityFeedbackRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionUpdateQualityFeedbackPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionUpdateQualityFeedbackPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlSuggestionQualityFeedbackRequest' is not null or undefined
            assertParamExists('suggestionUpdateQualityFeedbackPost', 'updateDzlSuggestionQualityFeedbackRequest', updateDzlSuggestionQualityFeedbackRequest);
            const localVarPath = `/api/dazzle/suggestion/update-quality-feedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlSuggestionQualityFeedbackRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update suggestions status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionsStatusInternalRequest} updateDzlSuggestionsStatusInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateStatusInternalPost: (xUserAgent_1, xDeviceID_1, updateDzlSuggestionsStatusInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlSuggestionsStatusInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlSuggestionsStatusInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionUpdateStatusInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionUpdateStatusInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlSuggestionsStatusInternalRequest' is not null or undefined
            assertParamExists('suggestionUpdateStatusInternalPost', 'updateDzlSuggestionsStatusInternalRequest', updateDzlSuggestionsStatusInternalRequest);
            const localVarPath = `/api/dazzle/suggestion/update-status-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlSuggestionsStatusInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update suggestions status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionsStatusRequest} updateDzlSuggestionsStatusRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateStatusPost: (xUserAgent_1, xDeviceID_1, updateDzlSuggestionsStatusRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlSuggestionsStatusRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlSuggestionsStatusRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('suggestionUpdateStatusPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('suggestionUpdateStatusPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlSuggestionsStatusRequest' is not null or undefined
            assertParamExists('suggestionUpdateStatusPost', 'updateDzlSuggestionsStatusRequest', updateDzlSuggestionsStatusRequest);
            const localVarPath = `/api/dazzle/suggestion/update-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlSuggestionsStatusRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a specific trace by ID.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetTraceRequest} getTraceRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceGetPost: (xUserAgent_1, xDeviceID_1, getTraceRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getTraceRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getTraceRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('traceGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('traceGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getTraceRequest' is not null or undefined
            assertParamExists('traceGetPost', 'getTraceRequest', getTraceRequest);
            const localVarPath = `/api/dazzle/trace/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getTraceRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all traces for a conversation.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListTracesRequest} listTracesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceListPost: (xUserAgent_1, xDeviceID_1, listTracesRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, listTracesRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, listTracesRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('traceListPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('traceListPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'listTracesRequest' is not null or undefined
            assertParamExists('traceListPost', 'listTracesRequest', listTracesRequest);
            const localVarPath = `/api/dazzle/trace/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listTracesRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDzlUserInternalRequest} getDzlUserInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetInternalPost: (xUserAgent_1, xDeviceID_1, getDzlUserInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, getDzlUserInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, getDzlUserInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('userGetInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('userGetInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'getDzlUserInternalRequest' is not null or undefined
            assertParamExists('userGetInternalPost', 'getDzlUserInternalRequest', getDzlUserInternalRequest);
            const localVarPath = `/api/dazzle/user/get-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getDzlUserInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPost: (xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, body_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, body, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('userGetPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('userGetPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'body' is not null or undefined
            assertParamExists('userGetPost', 'body', body);
            const localVarPath = `/api/dazzle/user/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set or clear a user\'s developer tier (internal admin).
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SetDeveloperTierInternalRequest} setDeveloperTierInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSetDeveloperTierInternalPost: (xUserAgent_1, xDeviceID_1, setDeveloperTierInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, setDeveloperTierInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, setDeveloperTierInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('userSetDeveloperTierInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('userSetDeveloperTierInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'setDeveloperTierInternalRequest' is not null or undefined
            assertParamExists('userSetDeveloperTierInternalPost', 'setDeveloperTierInternalRequest', setDeveloperTierInternalRequest);
            const localVarPath = `/api/dazzle/user/set-developer-tier-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setDeveloperTierInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update user details.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlUserInternalRequest} updateDzlUserInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateInternalPost: (xUserAgent_1, xDeviceID_1, updateDzlUserInternalRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlUserInternalRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlUserInternalRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('userUpdateInternalPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('userUpdateInternalPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlUserInternalRequest' is not null or undefined
            assertParamExists('userUpdateInternalPost', 'updateDzlUserInternalRequest', updateDzlUserInternalRequest);
            const localVarPath = `/api/dazzle/user/update-internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlUserInternalRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update user details.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlUserRequest} updateDzlUserRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdatePost: (xUserAgent_1, xDeviceID_1, updateDzlUserRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, updateDzlUserRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, updateDzlUserRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('userUpdatePost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('userUpdatePost', 'xDeviceID', xDeviceID);
            // verify required parameter 'updateDzlUserRequest' is not null or undefined
            assertParamExists('userUpdatePost', 'updateDzlUserRequest', updateDzlUserRequest);
            const localVarPath = `/api/dazzle/user/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateDzlUserRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create an Apple Wallet pass from barcode data.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreatePassRequest} createPassRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        walletCreatePassPost: (xUserAgent_1, xDeviceID_1, createPassRequest_1, xReqID_1, xRequestID_1, ...args_1) => __awaiter(this, [xUserAgent_1, xDeviceID_1, createPassRequest_1, xReqID_1, xRequestID_1, ...args_1], void 0, function* (xUserAgent, xDeviceID, createPassRequest, xReqID, xRequestID, options = {}) {
            // verify required parameter 'xUserAgent' is not null or undefined
            assertParamExists('walletCreatePassPost', 'xUserAgent', xUserAgent);
            // verify required parameter 'xDeviceID' is not null or undefined
            assertParamExists('walletCreatePassPost', 'xDeviceID', xDeviceID);
            // verify required parameter 'createPassRequest' is not null or undefined
            assertParamExists('walletCreatePassPost', 'createPassRequest', createPassRequest);
            const localVarPath = `/api/dazzle/wallet/create-pass`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (xUserAgent != null) {
                localVarHeaderParameter['X-User-Agent'] = String(xUserAgent);
            }
            if (xDeviceID != null) {
                localVarHeaderParameter['X-Device-ID'] = String(xDeviceID);
            }
            if (xReqID != null) {
                localVarHeaderParameter['X-Req-ID'] = String(xReqID);
            }
            if (xRequestID != null) {
                localVarHeaderParameter['X-Request-ID'] = String(xRequestID);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPassRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wellknownOauthAuthorizationServerGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/.well-known/oauth-authorization-server`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Refetch access token using refresh token in the cookie.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AccessTokenRequest} accessTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAccessTokenCookiesPost(xUserAgent, xDeviceID, accessTokenRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authAccessTokenCookiesPost(xUserAgent, xDeviceID, accessTokenRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authAccessTokenCookiesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Refetch access token using refresh token in the header.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AccessTokenRequest} accessTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAccessTokenPost(xUserAgent, xDeviceID, accessTokenRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authAccessTokenPost(xUserAgent, xDeviceID, accessTokenRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authAccessTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete refresh token cookie.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authDeleteRefreshTokenPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authDeleteRefreshTokenPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authDeleteRefreshTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all users for internal use.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllUsersInternalRequest} getAllUsersInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetAllUsersInternalPost(xUserAgent, xDeviceID, getAllUsersInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authGetAllUsersInternalPost(xUserAgent, xDeviceID, getAllUsersInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authGetAllUsersInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Opt out of service.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOptOutPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authOptOutPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authOptOutPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Send verification code to user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendVerificationCodeRequest} sendVerificationCodeRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSendVerificationCodePost(xUserAgent, xDeviceID, sendVerificationCodeRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authSendVerificationCodePost(xUserAgent, xDeviceID, sendVerificationCodeRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authSendVerificationCodePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sign in with verified code.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SignInRequest} signInRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignInPost(xUserAgent, xDeviceID, signInRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authSignInPost(xUserAgent, xDeviceID, signInRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authSignInPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update user device token.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDeviceTokenRequest} updateDeviceTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateDeviceTokenPost(xUserAgent, xDeviceID, updateDeviceTokenRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authUpdateDeviceTokenPost(xUserAgent, xDeviceID, updateDeviceTokenRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authUpdateDeviceTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Verify code.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {VerifyCodeRequest} verifyCodeRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyCodePost(xUserAgent, xDeviceID, verifyCodeRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authVerifyCodePost(xUserAgent, xDeviceID, verifyCodeRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.authVerifyCodePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Sync calendars and events.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CalendarSyncRequest} calendarSyncRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarSyncPost(xUserAgent, xDeviceID, calendarSyncRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.calendarSyncPost(xUserAgent, xDeviceID, calendarSyncRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.calendarSyncPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * <br/>Returns Server-Sent Events (text/event-stream). Each event contains a JSON object<br/>with one of these types: ThoughtMessage, StreamingChatDelta, StreamingChatComplete, or StreamingChatTiming.<br/><br/>Event format:<br/>- ThoughtMessage: {\"type\": \"thought\", \"message\": \"...\", \"tool_name\": \"...\"}<br/>- StreamingChatDelta: {\"type\": \"delta\", \"message\": \"...\"}<br/>- StreamingChatComplete: {\"type\": \"complete\", \"message\": {...}}<br/>- StreamingChatTiming: {\"type\": \"timing\", \"total_ms\": ..., \"breakdown\": {...}}
         * @summary Process a streaming chat completion request.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ChatRequest} chatRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStreamPost(xUserAgent, xDeviceID, chatRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.chatStreamPost(xUserAgent, xDeviceID, chatRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.chatStreamPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabConfirmDuplicatesRequest} clusteringLabConfirmDuplicatesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesConfirmPost(xUserAgent, xDeviceID, clusteringLabConfirmDuplicatesRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabDuplicatesConfirmPost(xUserAgent, xDeviceID, clusteringLabConfirmDuplicatesRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabDuplicatesConfirmPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListDuplicateSetsRequest} clusteringLabListDuplicateSetsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesListSetsPost(xUserAgent, xDeviceID, clusteringLabListDuplicateSetsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabDuplicatesListSetsPost(xUserAgent, xDeviceID, clusteringLabListDuplicateSetsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabDuplicatesListSetsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabMarkNotDuplicateRequest} clusteringLabMarkNotDuplicateRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesMarkNotDuplicatePost(xUserAgent, xDeviceID, clusteringLabMarkNotDuplicateRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabDuplicatesMarkNotDuplicatePost(xUserAgent, xDeviceID, clusteringLabMarkNotDuplicateRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabDuplicatesMarkNotDuplicatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabExportRequest} clusteringLabExportRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabExportPost(xUserAgent, xDeviceID, clusteringLabExportRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabExportPost(xUserAgent, xDeviceID, clusteringLabExportRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabExportPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabCreateGroupRequest} clusteringLabCreateGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsCreatePost(xUserAgent, xDeviceID, clusteringLabCreateGroupRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabGroupsCreatePost(xUserAgent, xDeviceID, clusteringLabCreateGroupRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabGroupsCreatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabDeleteGroupRequest} clusteringLabDeleteGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsDeletePost(xUserAgent, xDeviceID, clusteringLabDeleteGroupRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabGroupsDeletePost(xUserAgent, xDeviceID, clusteringLabDeleteGroupRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabGroupsDeletePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListGroupsRequest} clusteringLabListGroupsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsListPost(xUserAgent, xDeviceID, clusteringLabListGroupsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabGroupsListPost(xUserAgent, xDeviceID, clusteringLabListGroupsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabGroupsListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabUpdateGroupRequest} clusteringLabUpdateGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsUpdatePost(xUserAgent, xDeviceID, clusteringLabUpdateGroupRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabGroupsUpdatePost(xUserAgent, xDeviceID, clusteringLabUpdateGroupRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabGroupsUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabAssignMembersRequest} clusteringLabAssignMembersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabMembersAssignPost(xUserAgent, xDeviceID, clusteringLabAssignMembersRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabMembersAssignPost(xUserAgent, xDeviceID, clusteringLabAssignMembersRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabMembersAssignPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabUnassignMembersRequest} clusteringLabUnassignMembersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabMembersUnassignPost(xUserAgent, xDeviceID, clusteringLabUnassignMembersRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabMembersUnassignPost(xUserAgent, xDeviceID, clusteringLabUnassignMembersRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabMembersUnassignPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListPhotosRequest} clusteringLabListPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabPhotosListPost(xUserAgent, xDeviceID, clusteringLabListPhotosRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabPhotosListPost(xUserAgent, xDeviceID, clusteringLabListPhotosRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabPhotosListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabConfirmShareworthyRequest} clusteringLabConfirmShareworthyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabShareworthyConfirmPost(xUserAgent, xDeviceID, clusteringLabConfirmShareworthyRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabShareworthyConfirmPost(xUserAgent, xDeviceID, clusteringLabConfirmShareworthyRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabShareworthyConfirmPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClusteringLabListShareworthyRequest} clusteringLabListShareworthyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabShareworthyListPost(xUserAgent, xDeviceID, clusteringLabListShareworthyRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clusteringLabShareworthyListPost(xUserAgent, xDeviceID, clusteringLabListShareworthyRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.clusteringLabShareworthyListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Bulk delete conversations.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {BulkDeleteDzlConversationsRequest} bulkDeleteDzlConversationsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationBulkDeletePost(xUserAgent, xDeviceID, bulkDeleteDzlConversationsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationBulkDeletePost(xUserAgent, xDeviceID, bulkDeleteDzlConversationsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationBulkDeletePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get conversation for any user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreateDzlConversationInternalRequest} createDzlConversationInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationCreateInternalPost(xUserAgent, xDeviceID, createDzlConversationInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationCreateInternalPost(xUserAgent, xDeviceID, createDzlConversationInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationCreateInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get conversation for any user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DeleteDzlConversationInternalRequest} deleteDzlConversationInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationDeleteInternalPost(xUserAgent, xDeviceID, deleteDzlConversationInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationDeleteInternalPost(xUserAgent, xDeviceID, deleteDzlConversationInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationDeleteInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete conversation.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DeleteDzlConversationRequest} deleteDzlConversationRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationDeletePost(xUserAgent, xDeviceID, deleteDzlConversationRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationDeletePost(xUserAgent, xDeviceID, deleteDzlConversationRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationDeletePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all conversations for user (internal endpoint).
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetConversationsInternalRequest} getConversationsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetConversationsInternalPost(xUserAgent, xDeviceID, getConversationsInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationGetConversationsInternalPost(xUserAgent, xDeviceID, getConversationsInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationGetConversationsInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get conversation for any user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetConversationInternalRequest} getConversationInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetInternalPost(xUserAgent, xDeviceID, getConversationInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationGetInternalPost(xUserAgent, xDeviceID, getConversationInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationGetInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get single conversation.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDzlConversationRequest} getDzlConversationRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetPost(xUserAgent, xDeviceID, getDzlConversationRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationGetPost(xUserAgent, xDeviceID, getDzlConversationRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Increment copy count for a message.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {IncrementMessageCopyCountRequest} incrementMessageCopyCountRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationIncrementCopyCountPost(xUserAgent, xDeviceID, incrementMessageCopyCountRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationIncrementCopyCountPost(xUserAgent, xDeviceID, incrementMessageCopyCountRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationIncrementCopyCountPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all conversations.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllDzlConversationsRequest} getAllDzlConversationsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationListPost(xUserAgent, xDeviceID, getAllDzlConversationsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationListPost(xUserAgent, xDeviceID, getAllDzlConversationsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Send message as Dazzle.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendDazzleMessageRequest} sendDazzleMessageRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationSendAsDazzlePost(xUserAgent, xDeviceID, sendDazzleMessageRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.conversationSendAsDazzlePost(xUserAgent, xDeviceID, sendDazzleMessageRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.conversationSendAsDazzlePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create a new dataset entry.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlCreateDatasetEntryRequest} dzlCreateDatasetEntryRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetCreatePost(xUserAgent, xDeviceID, dzlCreateDatasetEntryRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalDatasetCreatePost(xUserAgent, xDeviceID, dzlCreateDatasetEntryRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalDatasetCreatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Soft-delete a dataset entry.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlDeleteDatasetEntryRequest} dzlDeleteDatasetEntryRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetDeletePost(xUserAgent, xDeviceID, dzlDeleteDatasetEntryRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalDatasetDeletePost(xUserAgent, xDeviceID, dzlDeleteDatasetEntryRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalDatasetDeletePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List dataset entries for a suite.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlListDatasetEntriesRequest} dzlListDatasetEntriesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetListPost(xUserAgent, xDeviceID, dzlListDatasetEntriesRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalDatasetListPost(xUserAgent, xDeviceID, dzlListDatasetEntriesRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalDatasetListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List candidate photos for seeding the golden dataset.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlListSeedCandidatesRequest} dzlListSeedCandidatesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetSeedCandidatesPost(xUserAgent, xDeviceID, dzlListSeedCandidatesRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalDatasetSeedCandidatesPost(xUserAgent, xDeviceID, dzlListSeedCandidatesRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalDatasetSeedCandidatesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update a dataset entry.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlUpdateDatasetEntryRequest} dzlUpdateDatasetEntryRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetUpdatePost(xUserAgent, xDeviceID, dzlUpdateDatasetEntryRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalDatasetUpdatePost(xUserAgent, xDeviceID, dzlUpdateDatasetEntryRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalDatasetUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get eval run status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlGetEvalRunRequest} dzlGetEvalRunRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunGetPost(xUserAgent, xDeviceID, dzlGetEvalRunRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalRunGetPost(xUserAgent, xDeviceID, dzlGetEvalRunRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalRunGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List recent eval runs.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlListEvalRunsRequest} dzlListEvalRunsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunListPost(xUserAgent, xDeviceID, dzlListEvalRunsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalRunListPost(xUserAgent, xDeviceID, dzlListEvalRunsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalRunListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get results for an eval run.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlGetEvalRunResultsRequest} dzlGetEvalRunResultsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunResultsPost(xUserAgent, xDeviceID, dzlGetEvalRunResultsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalRunResultsPost(xUserAgent, xDeviceID, dzlGetEvalRunResultsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalRunResultsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Start a new eval run.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlStartEvalRunRequest} dzlStartEvalRunRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunStartPost(xUserAgent, xDeviceID, dzlStartEvalRunRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.evalRunStartPost(xUserAgent, xDeviceID, dzlStartEvalRunRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.evalRunStartPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get important people.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faceGetImportantPeoplePost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.faceGetImportantPeoplePost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.faceGetImportantPeoplePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all photos for a specific person.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetPersonPhotosRequest} getPersonPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faceGetPersonPhotosPost(xUserAgent, xDeviceID, getPersonPhotosRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.faceGetPersonPhotosPost(xUserAgent, xDeviceID, getPersonPhotosRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.faceGetPersonPhotosPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Submit feedback for an LLM-produced item.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SubmitFeedbackRequest} submitFeedbackRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackSubmitPost(xUserAgent, xDeviceID, submitFeedbackRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.feedbackSubmitPost(xUserAgent, xDeviceID, submitFeedbackRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.feedbackSubmitPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Health check endpoint for deployment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.healthCheckHealthGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.healthCheckHealthGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get profile insights for the current user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetInsightsRequest} getInsightsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightGetInsightsPost(xUserAgent, xDeviceID, getInsightsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.insightGetInsightsPost(xUserAgent, xDeviceID, getInsightsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.insightGetInsightsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Mark insights as dismissed for the current user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {MarkInsightsDismissedRequest} markInsightsDismissedRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightMarkInsightsDismissedPost(xUserAgent, xDeviceID, markInsightsDismissedRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.insightMarkInsightsDismissedPost(xUserAgent, xDeviceID, markInsightsDismissedRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.insightMarkInsightsDismissedPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListMcpAgentsRequest} listMcpAgentsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAgentListPost(xUserAgent, xDeviceID, listMcpAgentsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpAgentListPost(xUserAgent, xDeviceID, listMcpAgentsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpAgentListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {RevokeMcpAgentRequest} revokeMcpAgentRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAgentRevokePost(xUserAgent, xDeviceID, revokeMcpAgentRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpAgentRevokePost(xUserAgent, xDeviceID, revokeMcpAgentRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpAgentRevokePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary JSON-RPC transport for /apps/<client_id>.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdPost(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpAppsStringClientIdPost(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpAppsStringClientIdPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary RFC 7591 dynamic client registration. Returns the pre-seeded client_id.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdRegisterPost(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpAppsStringClientIdRegisterPost(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpAppsStringClientIdRegisterPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary RFC 6749 token endpoint scoped to <client_id>; mints with per-client iss.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdTokenPost(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpAppsStringClientIdTokenPost(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpAppsStringClientIdTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Handle MCP JSON-RPC requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetMcpTraceRequest} getMcpTraceRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpTraceGetPost(xUserAgent, xDeviceID, getMcpTraceRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpTraceGetPost(xUserAgent, xDeviceID, getMcpTraceRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpTraceGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Page through MCP traces for a user, newest first.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListMcpTracesRequest} listMcpTracesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpTraceListPost(xUserAgent, xDeviceID, listMcpTracesRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpTraceListPost(xUserAgent, xDeviceID, listMcpTracesRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpTraceListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary RFC 8414 Authorization Server Metadata for /apps/<client_id>.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthAuthorizationServerAppsStringClientIdGet(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpWellknownOauthAuthorizationServerAppsStringClientIdGet(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpWellknownOauthAuthorizationServerAppsStringClientIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary RFC 9728 Protected Resource Metadata for /apps/<client_id>.
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthProtectedResourceAppsStringClientIdGet(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpWellknownOauthProtectedResourceAppsStringClientIdGet(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpWellknownOauthProtectedResourceAppsStringClientIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary RFC 9728 Protected Resource Metadata for the MCP endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthProtectedResourceGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpWellknownOauthProtectedResourceGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpWellknownOauthProtectedResourceGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * <br/>OpenAI supplies the token at directory-submission time; it is stored per environment in<br/>config (`OpenAiAppsChallenge`). Returns 404 until configured, so the route is inert<br/>before submission and never leaks a placeholder.
         * @summary Serve the OpenAI ChatGPT Apps domain-verification token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOpenaiAppsChallengeGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.mcpWellknownOpenaiAppsChallengeGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.mcpWellknownOpenaiAppsChallengeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Detailed monitoring endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCheckMonitorGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.monitorCheckMonitorGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.monitorCheckMonitorGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2AuthorizeGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2AuthorizeGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2AuthorizeGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2DeviceAuthorizationPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2DeviceAuthorizationPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2DeviceAuthorizationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {AuthorizeInternalRequest} authorizeInternalRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalAuthorizePost(authorizeInternalRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2InternalAuthorizePost(authorizeInternalRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2InternalAuthorizePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} clientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalClientsStringClientIdGet(clientId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2InternalClientsStringClientIdGet(clientId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2InternalClientsStringClientIdGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DeviceApproveRequest} deviceApproveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceApprovePost(deviceApproveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2InternalDeviceApprovePost(deviceApproveRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2InternalDeviceApprovePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DeviceApproveRequest} deviceApproveRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceDenyPost(deviceApproveRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2InternalDeviceDenyPost(deviceApproveRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2InternalDeviceDenyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {DeviceVerifyRequest} deviceVerifyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceVerifyPost(deviceVerifyRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2InternalDeviceVerifyPost(deviceVerifyRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2InternalDeviceVerifyPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2JwksGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2JwksGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2JwksGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2RevokePost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2RevokePost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2RevokePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2TokenPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.oauth2TokenPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.oauth2TokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get onboarding events with computed latencies for a user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetOnboardingEventsInternalRequest} getOnboardingEventsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingGetEventsInternalPost(xUserAgent, xDeviceID, getOnboardingEventsInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.onboardingGetEventsInternalPost(xUserAgent, xDeviceID, getOnboardingEventsInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.onboardingGetEventsInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Record an onboarding event for the current user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {RecordOnboardingEventRequest} recordOnboardingEventRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingRecordEventPost(xUserAgent, xDeviceID, recordOnboardingEventRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.onboardingRecordEventPost(xUserAgent, xDeviceID, recordOnboardingEventRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.onboardingRecordEventPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Assign order to fulfiller.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlAssignOrderRequest} dzlAssignOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAssignPost(xUserAgent, xDeviceID, dzlAssignOrderRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderAssignPost(xUserAgent, xDeviceID, dzlAssignOrderRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderAssignPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Mark order as complete.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlOrderCompleteRequest} dzlOrderCompleteRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCompletePost(xUserAgent, xDeviceID, dzlOrderCompleteRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderCompletePost(xUserAgent, xDeviceID, dzlOrderCompleteRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderCompletePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create an order from a suggestion.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreateDzlOrderFromSuggestionRequest} createDzlOrderFromSuggestionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateFromSuggestionPost(xUserAgent, xDeviceID, createDzlOrderFromSuggestionRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderCreateFromSuggestionPost(xUserAgent, xDeviceID, createDzlOrderFromSuggestionRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderCreateFromSuggestionPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlCreateOrderInternalRequest} dzlCreateOrderInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateInternalPost(xUserAgent, xDeviceID, dzlCreateOrderInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderCreateInternalPost(xUserAgent, xDeviceID, dzlCreateOrderInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderCreateInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlDeleteOrderInternalRequest} dzlDeleteOrderInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDeleteInternalPost(xUserAgent, xDeviceID, dzlDeleteOrderInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderDeleteInternalPost(xUserAgent, xDeviceID, dzlDeleteOrderInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderDeleteInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get single order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDzlOrderRequest} getDzlOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetPost(xUserAgent, xDeviceID, getDzlOrderRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderGetPost(xUserAgent, xDeviceID, getDzlOrderRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all orders.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllDzlOrdersRequest} getAllDzlOrdersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderListPost(xUserAgent, xDeviceID, getAllDzlOrdersRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderListPost(xUserAgent, xDeviceID, getAllDzlOrdersRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Process order payment.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlOrderPaymentRequest} dzlOrderPaymentRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPaymentPost(xUserAgent, xDeviceID, dzlOrderPaymentRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderPaymentPost(xUserAgent, xDeviceID, dzlOrderPaymentRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderPaymentPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Place a new order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {PlaceDzlOrderRequest} placeDzlOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPlacePost(xUserAgent, xDeviceID, placeDzlOrderRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderPlacePost(xUserAgent, xDeviceID, placeDzlOrderRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderPlacePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Send payment link to user via iMessage.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendPaymentLinkRequest} sendPaymentLinkRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSendPaymentLinkPost(xUserAgent, xDeviceID, sendPaymentLinkRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderSendPaymentLinkPost(xUserAgent, xDeviceID, sendPaymentLinkRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderSendPaymentLinkPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Clear Stripe information for a user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ClearDzlStripeRequest} clearDzlStripeRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeClearPost(xUserAgent, xDeviceID, clearDzlStripeRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderStripeClearPost(xUserAgent, xDeviceID, clearDzlStripeRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderStripeClearPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Confirm Stripe setup intent.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ConfirmDzlStripeSetupIntentRequest} confirmDzlStripeSetupIntentRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeConfirmSetupPost(xUserAgent, xDeviceID, confirmDzlStripeSetupIntentRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderStripeConfirmSetupPost(xUserAgent, xDeviceID, confirmDzlStripeSetupIntentRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderStripeConfirmSetupPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create Stripe setup intent.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeSetupIntentPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderStripeSetupIntentPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderStripeSetupIntentPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update order.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlUpdateOrderRequest} dzlUpdateOrderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderUpdatePost(xUserAgent, xDeviceID, dzlUpdateOrderRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.orderUpdatePost(xUserAgent, xDeviceID, dzlUpdateOrderRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.orderUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete photos by local asset IDs.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DeletePhotoRequest} deletePhotoRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoDeletePost(xUserAgent, xDeviceID, deletePhotoRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoDeletePost(xUserAgent, xDeviceID, deletePhotoRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoDeletePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Upload photo features/metadata for multiple photos.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UploadPhotoFeaturesRequest} uploadPhotoFeaturesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoFeaturesPost(xUserAgent, xDeviceID, uploadPhotoFeaturesRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoFeaturesPost(xUserAgent, xDeviceID, uploadPhotoFeaturesRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoFeaturesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get photo URLs for asset IDs.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetPhotoUrlsForAssetIdsRequest} getPhotoUrlsForAssetIdsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGetUrlsPost(xUserAgent, xDeviceID, getPhotoUrlsForAssetIdsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGetUrlsPost(xUserAgent, xDeviceID, getPhotoUrlsForAssetIdsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGetUrlsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Accept a photo group with optional custom tags.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AcceptPhotoGroupRequest} acceptPhotoGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupAcceptPost(xUserAgent, xDeviceID, acceptPhotoGroupRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupAcceptPost(xUserAgent, xDeviceID, acceptPhotoGroupRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupAcceptPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create a conversation thread from a photo group.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreateThreadFromGroupRequest} createThreadFromGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupCreateThreadPost(xUserAgent, xDeviceID, createThreadFromGroupRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupCreateThreadPost(xUserAgent, xDeviceID, createThreadFromGroupRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupCreateThreadPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Dismiss a photo group.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DismissPhotoGroupRequest} dismissPhotoGroupRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupDismissPost(xUserAgent, xDeviceID, dismissPhotoGroupRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupDismissPost(xUserAgent, xDeviceID, dismissPhotoGroupRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupDismissPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Start profile idea generation.
         * @param {GenerateProfileStartRequest} generateProfileStartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupGenerateProfileStartPost(generateProfileStartRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupGenerateProfileStartPost(generateProfileStartRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupGenerateProfileStartPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get photo groups and ideas for a user, with optional S3 URLs.
         * @param {GetUserPhotoGroupsAndIdeasRequest} getUserPhotoGroupsAndIdeasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupGetUserDataPost(getUserPhotoGroupsAndIdeasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupGetUserDataPost(getUserPhotoGroupsAndIdeasRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupGetUserDataPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List photo groups for the authenticated user.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListPhotoGroupsRequest} listPhotoGroupsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupListPost(xUserAgent, xDeviceID, listPhotoGroupsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupListPost(xUserAgent, xDeviceID, listPhotoGroupsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Regenerate photo groups and/or IDEAS for a specific user.
         * @param {RegenerateIdeasRequest} regenerateIdeasRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupRegenerateIdeasPost(regenerateIdeasRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupRegenerateIdeasPost(regenerateIdeasRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupRegenerateIdeasPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Start regeneration by marking pending for workers.
         * @param {RegenerateStartRequest} regenerateStartRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupRegenerateStartPost(regenerateStartRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupRegenerateStartPost(regenerateStartRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupRegenerateStartPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update tags for an existing photo group.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdatePhotoGroupTagsRequest} updatePhotoGroupTagsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupUpdateTagsPost(xUserAgent, xDeviceID, updatePhotoGroupTagsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoGroupUpdateTagsPost(xUserAgent, xDeviceID, updatePhotoGroupTagsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoGroupUpdateTagsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * <br/>Expects multipart/form-data with:<br/>- local_asset_id: The local asset ID<br/>- file: The photo file
         * @summary Upload a photo.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {File} file
         * @param {string} localAssetId
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoUploadPost(xUserAgent, xDeviceID, file, localAssetId, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.photoUploadPost(xUserAgent, xDeviceID, file, localAssetId, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.photoUploadPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreatePlatformApiKeyRequest} createPlatformApiKeyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyCreatePost(xUserAgent, xDeviceID, createPlatformApiKeyRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.platformKeyCreatePost(xUserAgent, xDeviceID, createPlatformApiKeyRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.platformKeyCreatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyListPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.platformKeyListPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.platformKeyListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {RevokePlatformApiKeyRequest} revokePlatformApiKeyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyRevokePost(xUserAgent, xDeviceID, revokePlatformApiKeyRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.platformKeyRevokePost(xUserAgent, xDeviceID, revokePlatformApiKeyRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.platformKeyRevokePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdatePlatformApiKeyRequest} updatePlatformApiKeyRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyUpdatePost(xUserAgent, xDeviceID, updatePlatformApiKeyRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.platformKeyUpdatePost(xUserAgent, xDeviceID, updatePlatformApiKeyRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.platformKeyUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabProcessChatRequest} profileLabProcessChatRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabChatProcessPost(xUserAgent, xDeviceID, profileLabProcessChatRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabChatProcessPost(xUserAgent, xDeviceID, profileLabProcessChatRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabChatProcessPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabExportDatasetRequest} profileLabExportDatasetRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabDatasetExportPost(xUserAgent, xDeviceID, profileLabExportDatasetRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabDatasetExportPost(xUserAgent, xDeviceID, profileLabExportDatasetRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabDatasetExportPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabListPeopleRequest} profileLabListPeopleRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPeopleListPost(xUserAgent, xDeviceID, profileLabListPeopleRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabPeopleListPost(xUserAgent, xDeviceID, profileLabListPeopleRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabPeopleListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabGetPersonPhotosRequest} profileLabGetPersonPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPeoplePhotosPost(xUserAgent, xDeviceID, profileLabGetPersonPhotosRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabPeoplePhotosPost(xUserAgent, xDeviceID, profileLabGetPersonPhotosRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabPeoplePhotosPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabListPhotosRequest} profileLabListPhotosRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPhotosListPost(xUserAgent, xDeviceID, profileLabListPhotosRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabPhotosListPost(xUserAgent, xDeviceID, profileLabListPhotosRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabPhotosListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabGetSignedUrlsRequest} profileLabGetSignedUrlsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPhotosSignedUrlsPost(xUserAgent, xDeviceID, profileLabGetSignedUrlsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabPhotosSignedUrlsPost(xUserAgent, xDeviceID, profileLabGetSignedUrlsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabPhotosSignedUrlsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabComputeSelectionRequest} profileLabComputeSelectionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabSelectionComputePost(xUserAgent, xDeviceID, profileLabComputeSelectionRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabSelectionComputePost(xUserAgent, xDeviceID, profileLabComputeSelectionRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabSelectionComputePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabRunStageRequest} profileLabRunStageRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagePreviewPost(xUserAgent, xDeviceID, profileLabRunStageRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabStagePreviewPost(xUserAgent, xDeviceID, profileLabRunStageRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabStagePreviewPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {number} userLid
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageResultGet(xUserAgent, xDeviceID, userLid, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabStageResultGet(xUserAgent, xDeviceID, userLid, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabStageResultGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabRunStageRequest} profileLabRunStageRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageRunPost(xUserAgent, xDeviceID, profileLabRunStageRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabStageRunPost(xUserAgent, xDeviceID, profileLabRunStageRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabStageRunPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {number} userLid
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageStatusGet(xUserAgent, xDeviceID, userLid, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabStageStatusGet(xUserAgent, xDeviceID, userLid, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabStageStatusGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ProfileLabGetStageDefinitionRequest} profileLabGetStageDefinitionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagesDefinitionPost(xUserAgent, xDeviceID, profileLabGetStageDefinitionRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabStagesDefinitionPost(xUserAgent, xDeviceID, profileLabGetStageDefinitionRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabStagesDefinitionPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagesListPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.profileLabStagesListPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.profileLabStagesListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Fetch prompts by type.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlFetchPromptsRequest} dzlFetchPromptsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptFetchPost(xUserAgent, xDeviceID, dzlFetchPromptsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.promptFetchPost(xUserAgent, xDeviceID, dzlFetchPromptsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.promptFetchPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update prompt text.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {DzlUpdatePromptRequest} dzlUpdatePromptRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptUpdatePost(xUserAgent, xDeviceID, dzlUpdatePromptRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.promptUpdatePost(xUserAgent, xDeviceID, dzlUpdatePromptRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.promptUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Add a new reminder.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {AddDzlReminderRequest} addDzlReminderRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderAddPost(xUserAgent, xDeviceID, addDzlReminderRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reminderAddPost(xUserAgent, xDeviceID, addDzlReminderRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.reminderAddPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get all reminders.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetAllDzlRemindersRequest} getAllDzlRemindersRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderListPost(xUserAgent, xDeviceID, getAllDzlRemindersRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reminderListPost(xUserAgent, xDeviceID, getAllDzlRemindersRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.reminderListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Schedule a reminder notification.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ScheduleReminderNotificationRequest} scheduleReminderNotificationRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderScheduleNotificationPost(xUserAgent, xDeviceID, scheduleReminderNotificationRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reminderScheduleNotificationPost(xUserAgent, xDeviceID, scheduleReminderNotificationRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.reminderScheduleNotificationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update reminder status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlReminderStatusRequest} updateDzlReminderStatusRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderUpdateStatusPost(xUserAgent, xDeviceID, updateDzlReminderStatusRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reminderUpdateStatusPost(xUserAgent, xDeviceID, updateDzlReminderStatusRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.reminderUpdateStatusPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {FeatureFlagCommandRequest} featureFlagCommandRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagCommandPost(xUserAgent, xDeviceID, featureFlagCommandRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revereFeatureFlagCommandPost(xUserAgent, xDeviceID, featureFlagCommandRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.revereFeatureFlagCommandPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagNamesPost(xUserAgent, xDeviceID, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revereFeatureFlagNamesPost(xUserAgent, xDeviceID, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.revereFeatureFlagNamesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetFeatureFlagStateRequest} getFeatureFlagStateRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagStatePost(xUserAgent, xDeviceID, getFeatureFlagStateRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revereFeatureFlagStatePost(xUserAgent, xDeviceID, getFeatureFlagStateRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.revereFeatureFlagStatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {TimerTaskCommandRequest} timerTaskCommandRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskCommandPost(xUserAgent, xDeviceID, timerTaskCommandRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revereTimerTaskCommandPost(xUserAgent, xDeviceID, timerTaskCommandRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.revereTimerTaskCommandPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskNamesPost(xUserAgent, xDeviceID, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revereTimerTaskNamesPost(xUserAgent, xDeviceID, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.revereTimerTaskNamesPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetTimerTaskStateRequest} getTimerTaskStateRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskStatePost(xUserAgent, xDeviceID, getTimerTaskStateRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.revereTimerTaskStatePost(xUserAgent, xDeviceID, getTimerTaskStateRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.revereTimerTaskStatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Receive webhook events from SendBlue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendblueWebhookWebhookPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendblueWebhookWebhookPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.sendblueWebhookWebhookPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get an access token from a Google OAuth refresh token in the cookie
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionRefreshAccessTokenPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionRefreshAccessTokenPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.sessionRefreshAccessTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Set a Google OAuth refresh token used in internal apps to a cookie
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SetRefreshTokenRequest} setRefreshTokenRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionSetRefreshTokenPost(xUserAgent, xDeviceID, setRefreshTokenRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sessionSetRefreshTokenPost(xUserAgent, xDeviceID, setRefreshTokenRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.sessionSetRefreshTokenPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Receive webhook events from Twilio shortcode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortcodeWebhookWebhookPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.shortcodeWebhookWebhookPost(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.shortcodeWebhookWebhookPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get deduped suggestions for user (internal endpoint).
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDedupedSuggestionsInternalRequest} getDedupedSuggestionsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetDedupedSuggestionsInternalPost(xUserAgent, xDeviceID, getDedupedSuggestionsInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetDedupedSuggestionsInternalPost(xUserAgent, xDeviceID, getDedupedSuggestionsInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetDedupedSuggestionsInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get reviewable suggestions with pagination.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetSuggestionInternalRequest} getSuggestionInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetInternalPost(xUserAgent, xDeviceID, getSuggestionInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetInternalPost(xUserAgent, xDeviceID, getSuggestionInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get pending suggestions.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetPendingDzlSuggestionsRequest} getPendingDzlSuggestionsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetPendingPost(xUserAgent, xDeviceID, getPendingDzlSuggestionsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetPendingPost(xUserAgent, xDeviceID, getPendingDzlSuggestionsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetPendingPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a single suggestion by ID.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetSuggestionRequest} getSuggestionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetPost(xUserAgent, xDeviceID, getSuggestionRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetPost(xUserAgent, xDeviceID, getSuggestionRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get global quality feedback statistics.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetQualityFeedbackStatsInternalRequest} getQualityFeedbackStatsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetQualityFeedbackStatsInternalPost(xUserAgent, xDeviceID, getQualityFeedbackStatsInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetQualityFeedbackStatsInternalPost(xUserAgent, xDeviceID, getQualityFeedbackStatsInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetQualityFeedbackStatsInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get reviewable suggestions with pagination.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetReviewableSuggestionsInternalRequest} getReviewableSuggestionsInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetReviewableInternalPost(xUserAgent, xDeviceID, getReviewableSuggestionsInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetReviewableInternalPost(xUserAgent, xDeviceID, getReviewableSuggestionsInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetReviewableInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get suggestions with pagination and optional uniform per-type limit.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetSuggestionsRequest} getSuggestionsRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetSuggestionsPost(xUserAgent, xDeviceID, getSuggestionsRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionGetSuggestionsPost(xUserAgent, xDeviceID, getSuggestionsRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionGetSuggestionsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Materialize a quick suggestion by persisting photo and suggestion to storage.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {File} file
         * @param {string} localAssetId
         * @param {Suggestion} suggestionData
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionQuickSuggestionMaterializePost(xUserAgent, xDeviceID, file, localAssetId, suggestionData, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionQuickSuggestionMaterializePost(xUserAgent, xDeviceID, file, localAssetId, suggestionData, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionQuickSuggestionMaterializePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a quick suggestion from an image.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {File} file
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {string | null} [localAssetId]
         * @param {string | null} [model]
         * @param {string | null} [photoTs]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionQuickSuggestionPost(xUserAgent, xDeviceID, file, xReqID, xRequestID, localAssetId, model, photoTs, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionQuickSuggestionPost(xUserAgent, xDeviceID, file, xReqID, xRequestID, localAssetId, model, photoTs, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionQuickSuggestionPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Send transcription email.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SendDzlTranscriptionEmailRequest} sendDzlTranscriptionEmailRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionSendEmailPost(xUserAgent, xDeviceID, sendDzlTranscriptionEmailRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionSendEmailPost(xUserAgent, xDeviceID, sendDzlTranscriptionEmailRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionSendEmailPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Start a conversation from a suggestion.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {StartConversationFromSuggestionRequest} startConversationFromSuggestionRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionStartConversationPost(xUserAgent, xDeviceID, startConversationFromSuggestionRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionStartConversationPost(xUserAgent, xDeviceID, startConversationFromSuggestionRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionStartConversationPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update suggestions status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionInternalRequest} updateDzlSuggestionInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateInternalPost(xUserAgent, xDeviceID, updateDzlSuggestionInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionUpdateInternalPost(xUserAgent, xDeviceID, updateDzlSuggestionInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionUpdateInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update suggestion quality feedback.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionQualityFeedbackRequest} updateDzlSuggestionQualityFeedbackRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateQualityFeedbackPost(xUserAgent, xDeviceID, updateDzlSuggestionQualityFeedbackRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionUpdateQualityFeedbackPost(xUserAgent, xDeviceID, updateDzlSuggestionQualityFeedbackRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionUpdateQualityFeedbackPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update suggestions status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionsStatusInternalRequest} updateDzlSuggestionsStatusInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateStatusInternalPost(xUserAgent, xDeviceID, updateDzlSuggestionsStatusInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionUpdateStatusInternalPost(xUserAgent, xDeviceID, updateDzlSuggestionsStatusInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionUpdateStatusInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update suggestions status.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlSuggestionsStatusRequest} updateDzlSuggestionsStatusRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateStatusPost(xUserAgent, xDeviceID, updateDzlSuggestionsStatusRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestionUpdateStatusPost(xUserAgent, xDeviceID, updateDzlSuggestionsStatusRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.suggestionUpdateStatusPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a specific trace by ID.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetTraceRequest} getTraceRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceGetPost(xUserAgent, xDeviceID, getTraceRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.traceGetPost(xUserAgent, xDeviceID, getTraceRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.traceGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List all traces for a conversation.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {ListTracesRequest} listTracesRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceListPost(xUserAgent, xDeviceID, listTracesRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.traceListPost(xUserAgent, xDeviceID, listTracesRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.traceListPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {GetDzlUserInternalRequest} getDzlUserInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetInternalPost(xUserAgent, xDeviceID, getDzlUserInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userGetInternalPost(xUserAgent, xDeviceID, getDzlUserInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.userGetInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {object} body
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userGetPost(xUserAgent, xDeviceID, body, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.userGetPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Set or clear a user\'s developer tier (internal admin).
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {SetDeveloperTierInternalRequest} setDeveloperTierInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSetDeveloperTierInternalPost(xUserAgent, xDeviceID, setDeveloperTierInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userSetDeveloperTierInternalPost(xUserAgent, xDeviceID, setDeveloperTierInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.userSetDeveloperTierInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update user details.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlUserInternalRequest} updateDzlUserInternalRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateInternalPost(xUserAgent, xDeviceID, updateDzlUserInternalRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userUpdateInternalPost(xUserAgent, xDeviceID, updateDzlUserInternalRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.userUpdateInternalPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update user details.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {UpdateDzlUserRequest} updateDzlUserRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdatePost(xUserAgent, xDeviceID, updateDzlUserRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.userUpdatePost(xUserAgent, xDeviceID, updateDzlUserRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.userUpdatePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Create an Apple Wallet pass from barcode data.
         * @param {string} xUserAgent Format: &lt;Product&gt;/&lt;app version&gt; (&lt;device&gt; &lt;device version&gt;; &lt;OS&gt; &lt;os version&gt;)
         * @param {string} xDeviceID Unique device identifier
         * @param {CreatePassRequest} createPassRequest
         * @param {string} [xReqID] Dazzle-specific unique request identifier for tracing
         * @param {string | null} [xRequestID] Unique request identifier for tracing
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        walletCreatePassPost(xUserAgent, xDeviceID, createPassRequest, xReqID, xRequestID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.walletCreatePassPost(xUserAgent, xDeviceID, createPassRequest, xReqID, xRequestID, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.walletCreatePassPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wellknownOauthAuthorizationServerGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.wellknownOauthAuthorizationServerGet(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['DefaultApi.wellknownOauthAuthorizationServerGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary Refetch access token using refresh token in the cookie.
         * @param {DefaultApiAuthAccessTokenCookiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAccessTokenCookiesPost(requestParameters, options) {
            return localVarFp.authAccessTokenCookiesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.accessTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Refetch access token using refresh token in the header.
         * @param {DefaultApiAuthAccessTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authAccessTokenPost(requestParameters, options) {
            return localVarFp.authAccessTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.accessTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete refresh token cookie.
         * @param {DefaultApiAuthDeleteRefreshTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authDeleteRefreshTokenPost(requestParameters, options) {
            return localVarFp.authDeleteRefreshTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all users for internal use.
         * @param {DefaultApiAuthGetAllUsersInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authGetAllUsersInternalPost(requestParameters, options) {
            return localVarFp.authGetAllUsersInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllUsersInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Opt out of service.
         * @param {DefaultApiAuthOptOutPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authOptOutPost(requestParameters, options) {
            return localVarFp.authOptOutPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send verification code to user.
         * @param {DefaultApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSendVerificationCodePost(requestParameters, options) {
            return localVarFp.authSendVerificationCodePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendVerificationCodeRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sign in with verified code.
         * @param {DefaultApiAuthSignInPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSignInPost(requestParameters, options) {
            return localVarFp.authSignInPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.signInRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user device token.
         * @param {DefaultApiAuthUpdateDeviceTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateDeviceTokenPost(requestParameters, options) {
            return localVarFp.authUpdateDeviceTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDeviceTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify code.
         * @param {DefaultApiAuthVerifyCodePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyCodePost(requestParameters, options) {
            return localVarFp.authVerifyCodePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.verifyCodeRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sync calendars and events.
         * @param {DefaultApiCalendarSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calendarSyncPost(requestParameters, options) {
            return localVarFp.calendarSyncPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.calendarSyncRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * <br/>Returns Server-Sent Events (text/event-stream). Each event contains a JSON object<br/>with one of these types: ThoughtMessage, StreamingChatDelta, StreamingChatComplete, or StreamingChatTiming.<br/><br/>Event format:<br/>- ThoughtMessage: {\"type\": \"thought\", \"message\": \"...\", \"tool_name\": \"...\"}<br/>- StreamingChatDelta: {\"type\": \"delta\", \"message\": \"...\"}<br/>- StreamingChatComplete: {\"type\": \"complete\", \"message\": {...}}<br/>- StreamingChatTiming: {\"type\": \"timing\", \"total_ms\": ..., \"breakdown\": {...}}
         * @summary Process a streaming chat completion request.
         * @param {DefaultApiChatStreamPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatStreamPost(requestParameters, options) {
            return localVarFp.chatStreamPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.chatRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabDuplicatesConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesConfirmPost(requestParameters, options) {
            return localVarFp.clusteringLabDuplicatesConfirmPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabConfirmDuplicatesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabDuplicatesListSetsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesListSetsPost(requestParameters, options) {
            return localVarFp.clusteringLabDuplicatesListSetsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListDuplicateSetsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabDuplicatesMarkNotDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabDuplicatesMarkNotDuplicatePost(requestParameters, options) {
            return localVarFp.clusteringLabDuplicatesMarkNotDuplicatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabMarkNotDuplicateRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabExportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabExportPost(requestParameters, options) {
            return localVarFp.clusteringLabExportPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabExportRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabGroupsCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsCreatePost(requestParameters, options) {
            return localVarFp.clusteringLabGroupsCreatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabCreateGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabGroupsDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsDeletePost(requestParameters, options) {
            return localVarFp.clusteringLabGroupsDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabDeleteGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabGroupsListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsListPost(requestParameters, options) {
            return localVarFp.clusteringLabGroupsListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListGroupsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabGroupsUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabGroupsUpdatePost(requestParameters, options) {
            return localVarFp.clusteringLabGroupsUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabUpdateGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabMembersAssignPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabMembersAssignPost(requestParameters, options) {
            return localVarFp.clusteringLabMembersAssignPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabAssignMembersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabMembersUnassignPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabMembersUnassignPost(requestParameters, options) {
            return localVarFp.clusteringLabMembersUnassignPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabUnassignMembersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabPhotosListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabPhotosListPost(requestParameters, options) {
            return localVarFp.clusteringLabPhotosListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabShareworthyConfirmPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabShareworthyConfirmPost(requestParameters, options) {
            return localVarFp.clusteringLabShareworthyConfirmPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabConfirmShareworthyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiClusteringLabShareworthyListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clusteringLabShareworthyListPost(requestParameters, options) {
            return localVarFp.clusteringLabShareworthyListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListShareworthyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bulk delete conversations.
         * @param {DefaultApiConversationBulkDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationBulkDeletePost(requestParameters, options) {
            return localVarFp.conversationBulkDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.bulkDeleteDzlConversationsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get conversation for any user.
         * @param {DefaultApiConversationCreateInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationCreateInternalPost(requestParameters, options) {
            return localVarFp.conversationCreateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createDzlConversationInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get conversation for any user.
         * @param {DefaultApiConversationDeleteInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationDeleteInternalPost(requestParameters, options) {
            return localVarFp.conversationDeleteInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.deleteDzlConversationInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete conversation.
         * @param {DefaultApiConversationDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationDeletePost(requestParameters, options) {
            return localVarFp.conversationDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.deleteDzlConversationRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all conversations for user (internal endpoint).
         * @param {DefaultApiConversationGetConversationsInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetConversationsInternalPost(requestParameters, options) {
            return localVarFp.conversationGetConversationsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getConversationsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get conversation for any user.
         * @param {DefaultApiConversationGetInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetInternalPost(requestParameters, options) {
            return localVarFp.conversationGetInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getConversationInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get single conversation.
         * @param {DefaultApiConversationGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationGetPost(requestParameters, options) {
            return localVarFp.conversationGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDzlConversationRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Increment copy count for a message.
         * @param {DefaultApiConversationIncrementCopyCountPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationIncrementCopyCountPost(requestParameters, options) {
            return localVarFp.conversationIncrementCopyCountPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.incrementMessageCopyCountRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all conversations.
         * @param {DefaultApiConversationListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationListPost(requestParameters, options) {
            return localVarFp.conversationListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllDzlConversationsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send message as Dazzle.
         * @param {DefaultApiConversationSendAsDazzlePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        conversationSendAsDazzlePost(requestParameters, options) {
            return localVarFp.conversationSendAsDazzlePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendDazzleMessageRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a new dataset entry.
         * @param {DefaultApiEvalDatasetCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetCreatePost(requestParameters, options) {
            return localVarFp.evalDatasetCreatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlCreateDatasetEntryRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Soft-delete a dataset entry.
         * @param {DefaultApiEvalDatasetDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetDeletePost(requestParameters, options) {
            return localVarFp.evalDatasetDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlDeleteDatasetEntryRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List dataset entries for a suite.
         * @param {DefaultApiEvalDatasetListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetListPost(requestParameters, options) {
            return localVarFp.evalDatasetListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlListDatasetEntriesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List candidate photos for seeding the golden dataset.
         * @param {DefaultApiEvalDatasetSeedCandidatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetSeedCandidatesPost(requestParameters, options) {
            return localVarFp.evalDatasetSeedCandidatesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlListSeedCandidatesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a dataset entry.
         * @param {DefaultApiEvalDatasetUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalDatasetUpdatePost(requestParameters, options) {
            return localVarFp.evalDatasetUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlUpdateDatasetEntryRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get eval run status.
         * @param {DefaultApiEvalRunGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunGetPost(requestParameters, options) {
            return localVarFp.evalRunGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlGetEvalRunRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List recent eval runs.
         * @param {DefaultApiEvalRunListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunListPost(requestParameters, options) {
            return localVarFp.evalRunListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlListEvalRunsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get results for an eval run.
         * @param {DefaultApiEvalRunResultsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunResultsPost(requestParameters, options) {
            return localVarFp.evalRunResultsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlGetEvalRunResultsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start a new eval run.
         * @param {DefaultApiEvalRunStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evalRunStartPost(requestParameters, options) {
            return localVarFp.evalRunStartPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlStartEvalRunRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get important people.
         * @param {DefaultApiFaceGetImportantPeoplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faceGetImportantPeoplePost(requestParameters, options) {
            return localVarFp.faceGetImportantPeoplePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all photos for a specific person.
         * @param {DefaultApiFaceGetPersonPhotosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        faceGetPersonPhotosPost(requestParameters, options) {
            return localVarFp.faceGetPersonPhotosPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getPersonPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit feedback for an LLM-produced item.
         * @param {DefaultApiFeedbackSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feedbackSubmitPost(requestParameters, options) {
            return localVarFp.feedbackSubmitPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.submitFeedbackRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Health check endpoint for deployment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheckHealthGet(options) {
            return localVarFp.healthCheckHealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get profile insights for the current user.
         * @param {DefaultApiInsightGetInsightsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightGetInsightsPost(requestParameters, options) {
            return localVarFp.insightGetInsightsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getInsightsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark insights as dismissed for the current user.
         * @param {DefaultApiInsightMarkInsightsDismissedPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insightMarkInsightsDismissedPost(requestParameters, options) {
            return localVarFp.insightMarkInsightsDismissedPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.markInsightsDismissedRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiMcpAgentListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAgentListPost(requestParameters, options) {
            return localVarFp.mcpAgentListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listMcpAgentsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiMcpAgentRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAgentRevokePost(requestParameters, options) {
            return localVarFp.mcpAgentRevokePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.revokeMcpAgentRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary JSON-RPC transport for /apps/<client_id>.
         * @param {DefaultApiMcpAppsStringClientIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdPost(requestParameters, options) {
            return localVarFp.mcpAppsStringClientIdPost(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary RFC 7591 dynamic client registration. Returns the pre-seeded client_id.
         * @param {DefaultApiMcpAppsStringClientIdRegisterPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdRegisterPost(requestParameters, options) {
            return localVarFp.mcpAppsStringClientIdRegisterPost(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary RFC 6749 token endpoint scoped to <client_id>; mints with per-client iss.
         * @param {DefaultApiMcpAppsStringClientIdTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpAppsStringClientIdTokenPost(requestParameters, options) {
            return localVarFp.mcpAppsStringClientIdTokenPost(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Handle MCP JSON-RPC requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpPost(options) {
            return localVarFp.mcpPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiMcpTraceGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpTraceGetPost(requestParameters, options) {
            return localVarFp.mcpTraceGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getMcpTraceRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Page through MCP traces for a user, newest first.
         * @param {DefaultApiMcpTraceListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpTraceListPost(requestParameters, options) {
            return localVarFp.mcpTraceListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listMcpTracesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary RFC 8414 Authorization Server Metadata for /apps/<client_id>.
         * @param {DefaultApiMcpWellknownOauthAuthorizationServerAppsStringClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthAuthorizationServerAppsStringClientIdGet(requestParameters, options) {
            return localVarFp.mcpWellknownOauthAuthorizationServerAppsStringClientIdGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary RFC 9728 Protected Resource Metadata for /apps/<client_id>.
         * @param {DefaultApiMcpWellknownOauthProtectedResourceAppsStringClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthProtectedResourceAppsStringClientIdGet(requestParameters, options) {
            return localVarFp.mcpWellknownOauthProtectedResourceAppsStringClientIdGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary RFC 9728 Protected Resource Metadata for the MCP endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOauthProtectedResourceGet(options) {
            return localVarFp.mcpWellknownOauthProtectedResourceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * <br/>OpenAI supplies the token at directory-submission time; it is stored per environment in<br/>config (`OpenAiAppsChallenge`). Returns 404 until configured, so the route is inert<br/>before submission and never leaks a placeholder.
         * @summary Serve the OpenAI ChatGPT Apps domain-verification token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mcpWellknownOpenaiAppsChallengeGet(options) {
            return localVarFp.mcpWellknownOpenaiAppsChallengeGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Detailed monitoring endpoint.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        monitorCheckMonitorGet(options) {
            return localVarFp.monitorCheckMonitorGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2AuthorizeGet(options) {
            return localVarFp.oauth2AuthorizeGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2DeviceAuthorizationPost(options) {
            return localVarFp.oauth2DeviceAuthorizationPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiOauth2InternalAuthorizePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalAuthorizePost(requestParameters, options) {
            return localVarFp.oauth2InternalAuthorizePost(requestParameters.authorizeInternalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiOauth2InternalClientsStringClientIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalClientsStringClientIdGet(requestParameters, options) {
            return localVarFp.oauth2InternalClientsStringClientIdGet(requestParameters.clientId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiOauth2InternalDeviceApprovePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceApprovePost(requestParameters, options) {
            return localVarFp.oauth2InternalDeviceApprovePost(requestParameters.deviceApproveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiOauth2InternalDeviceDenyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceDenyPost(requestParameters, options) {
            return localVarFp.oauth2InternalDeviceDenyPost(requestParameters.deviceApproveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiOauth2InternalDeviceVerifyPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2InternalDeviceVerifyPost(requestParameters, options) {
            return localVarFp.oauth2InternalDeviceVerifyPost(requestParameters.deviceVerifyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2JwksGet(options) {
            return localVarFp.oauth2JwksGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2RevokePost(options) {
            return localVarFp.oauth2RevokePost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        oauth2TokenPost(options) {
            return localVarFp.oauth2TokenPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get onboarding events with computed latencies for a user.
         * @param {DefaultApiOnboardingGetEventsInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingGetEventsInternalPost(requestParameters, options) {
            return localVarFp.onboardingGetEventsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getOnboardingEventsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Record an onboarding event for the current user.
         * @param {DefaultApiOnboardingRecordEventPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardingRecordEventPost(requestParameters, options) {
            return localVarFp.onboardingRecordEventPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.recordOnboardingEventRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Assign order to fulfiller.
         * @param {DefaultApiOrderAssignPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderAssignPost(requestParameters, options) {
            return localVarFp.orderAssignPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlAssignOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mark order as complete.
         * @param {DefaultApiOrderCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCompletePost(requestParameters, options) {
            return localVarFp.orderCompletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlOrderCompleteRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an order from a suggestion.
         * @param {DefaultApiOrderCreateFromSuggestionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateFromSuggestionPost(requestParameters, options) {
            return localVarFp.orderCreateFromSuggestionPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createDzlOrderFromSuggestionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create order.
         * @param {DefaultApiOrderCreateInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCreateInternalPost(requestParameters, options) {
            return localVarFp.orderCreateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlCreateOrderInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete order.
         * @param {DefaultApiOrderDeleteInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderDeleteInternalPost(requestParameters, options) {
            return localVarFp.orderDeleteInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlDeleteOrderInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get single order.
         * @param {DefaultApiOrderGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderGetPost(requestParameters, options) {
            return localVarFp.orderGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDzlOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all orders.
         * @param {DefaultApiOrderListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderListPost(requestParameters, options) {
            return localVarFp.orderListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllDzlOrdersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Process order payment.
         * @param {DefaultApiOrderPaymentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPaymentPost(requestParameters, options) {
            return localVarFp.orderPaymentPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlOrderPaymentRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Place a new order.
         * @param {DefaultApiOrderPlacePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderPlacePost(requestParameters, options) {
            return localVarFp.orderPlacePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.placeDzlOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send payment link to user via iMessage.
         * @param {DefaultApiOrderSendPaymentLinkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderSendPaymentLinkPost(requestParameters, options) {
            return localVarFp.orderSendPaymentLinkPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendPaymentLinkRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Clear Stripe information for a user.
         * @param {DefaultApiOrderStripeClearPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeClearPost(requestParameters, options) {
            return localVarFp.orderStripeClearPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clearDzlStripeRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirm Stripe setup intent.
         * @param {DefaultApiOrderStripeConfirmSetupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeConfirmSetupPost(requestParameters, options) {
            return localVarFp.orderStripeConfirmSetupPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.confirmDzlStripeSetupIntentRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Stripe setup intent.
         * @param {DefaultApiOrderStripeSetupIntentPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStripeSetupIntentPost(requestParameters, options) {
            return localVarFp.orderStripeSetupIntentPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update order.
         * @param {DefaultApiOrderUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderUpdatePost(requestParameters, options) {
            return localVarFp.orderUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlUpdateOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete photos by local asset IDs.
         * @param {DefaultApiPhotoDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoDeletePost(requestParameters, options) {
            return localVarFp.photoDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.deletePhotoRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upload photo features/metadata for multiple photos.
         * @param {DefaultApiPhotoFeaturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoFeaturesPost(requestParameters, options) {
            return localVarFp.photoFeaturesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.uploadPhotoFeaturesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get photo URLs for asset IDs.
         * @param {DefaultApiPhotoGetUrlsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGetUrlsPost(requestParameters, options) {
            return localVarFp.photoGetUrlsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getPhotoUrlsForAssetIdsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Accept a photo group with optional custom tags.
         * @param {DefaultApiPhotoGroupAcceptPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupAcceptPost(requestParameters, options) {
            return localVarFp.photoGroupAcceptPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.acceptPhotoGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a conversation thread from a photo group.
         * @param {DefaultApiPhotoGroupCreateThreadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupCreateThreadPost(requestParameters, options) {
            return localVarFp.photoGroupCreateThreadPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createThreadFromGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Dismiss a photo group.
         * @param {DefaultApiPhotoGroupDismissPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupDismissPost(requestParameters, options) {
            return localVarFp.photoGroupDismissPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dismissPhotoGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start profile idea generation.
         * @param {DefaultApiPhotoGroupGenerateProfileStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupGenerateProfileStartPost(requestParameters, options) {
            return localVarFp.photoGroupGenerateProfileStartPost(requestParameters.generateProfileStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get photo groups and ideas for a user, with optional S3 URLs.
         * @param {DefaultApiPhotoGroupGetUserDataPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupGetUserDataPost(requestParameters, options) {
            return localVarFp.photoGroupGetUserDataPost(requestParameters.getUserPhotoGroupsAndIdeasRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List photo groups for the authenticated user.
         * @param {DefaultApiPhotoGroupListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupListPost(requestParameters, options) {
            return localVarFp.photoGroupListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listPhotoGroupsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Regenerate photo groups and/or IDEAS for a specific user.
         * @param {DefaultApiPhotoGroupRegenerateIdeasPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupRegenerateIdeasPost(requestParameters, options) {
            return localVarFp.photoGroupRegenerateIdeasPost(requestParameters.regenerateIdeasRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start regeneration by marking pending for workers.
         * @param {DefaultApiPhotoGroupRegenerateStartPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupRegenerateStartPost(requestParameters, options) {
            return localVarFp.photoGroupRegenerateStartPost(requestParameters.regenerateStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update tags for an existing photo group.
         * @param {DefaultApiPhotoGroupUpdateTagsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoGroupUpdateTagsPost(requestParameters, options) {
            return localVarFp.photoGroupUpdateTagsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updatePhotoGroupTagsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         * <br/>Expects multipart/form-data with:<br/>- local_asset_id: The local asset ID<br/>- file: The photo file
         * @summary Upload a photo.
         * @param {DefaultApiPhotoUploadPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoUploadPost(requestParameters, options) {
            return localVarFp.photoUploadPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.file, requestParameters.localAssetId, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiPlatformKeyCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyCreatePost(requestParameters, options) {
            return localVarFp.platformKeyCreatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createPlatformApiKeyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiPlatformKeyListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyListPost(requestParameters, options) {
            return localVarFp.platformKeyListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiPlatformKeyRevokePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyRevokePost(requestParameters, options) {
            return localVarFp.platformKeyRevokePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.revokePlatformApiKeyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiPlatformKeyUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        platformKeyUpdatePost(requestParameters, options) {
            return localVarFp.platformKeyUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updatePlatformApiKeyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabChatProcessPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabChatProcessPost(requestParameters, options) {
            return localVarFp.profileLabChatProcessPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabProcessChatRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabDatasetExportPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabDatasetExportPost(requestParameters, options) {
            return localVarFp.profileLabDatasetExportPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabExportDatasetRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabPeopleListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPeopleListPost(requestParameters, options) {
            return localVarFp.profileLabPeopleListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabListPeopleRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabPeoplePhotosPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPeoplePhotosPost(requestParameters, options) {
            return localVarFp.profileLabPeoplePhotosPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabGetPersonPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabPhotosListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPhotosListPost(requestParameters, options) {
            return localVarFp.profileLabPhotosListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabListPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabPhotosSignedUrlsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabPhotosSignedUrlsPost(requestParameters, options) {
            return localVarFp.profileLabPhotosSignedUrlsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabGetSignedUrlsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabSelectionComputePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabSelectionComputePost(requestParameters, options) {
            return localVarFp.profileLabSelectionComputePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabComputeSelectionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabStagePreviewPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagePreviewPost(requestParameters, options) {
            return localVarFp.profileLabStagePreviewPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabRunStageRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabStageResultGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageResultGet(requestParameters, options) {
            return localVarFp.profileLabStageResultGet(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.userLid, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabStageRunPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageRunPost(requestParameters, options) {
            return localVarFp.profileLabStageRunPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabRunStageRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabStageStatusGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStageStatusGet(requestParameters, options) {
            return localVarFp.profileLabStageStatusGet(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.userLid, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabStagesDefinitionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagesDefinitionPost(requestParameters, options) {
            return localVarFp.profileLabStagesDefinitionPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabGetStageDefinitionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiProfileLabStagesListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileLabStagesListPost(requestParameters, options) {
            return localVarFp.profileLabStagesListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch prompts by type.
         * @param {DefaultApiPromptFetchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptFetchPost(requestParameters, options) {
            return localVarFp.promptFetchPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlFetchPromptsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update prompt text.
         * @param {DefaultApiPromptUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptUpdatePost(requestParameters, options) {
            return localVarFp.promptUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlUpdatePromptRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add a new reminder.
         * @param {DefaultApiReminderAddPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderAddPost(requestParameters, options) {
            return localVarFp.reminderAddPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.addDzlReminderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all reminders.
         * @param {DefaultApiReminderListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderListPost(requestParameters, options) {
            return localVarFp.reminderListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllDzlRemindersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule a reminder notification.
         * @param {DefaultApiReminderScheduleNotificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderScheduleNotificationPost(requestParameters, options) {
            return localVarFp.reminderScheduleNotificationPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.scheduleReminderNotificationRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update reminder status.
         * @param {DefaultApiReminderUpdateStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reminderUpdateStatusPost(requestParameters, options) {
            return localVarFp.reminderUpdateStatusPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlReminderStatusRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiRevereFeatureFlagCommandPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagCommandPost(requestParameters, options) {
            return localVarFp.revereFeatureFlagCommandPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.featureFlagCommandRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiRevereFeatureFlagNamesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagNamesPost(requestParameters, options) {
            return localVarFp.revereFeatureFlagNamesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiRevereFeatureFlagStatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereFeatureFlagStatePost(requestParameters, options) {
            return localVarFp.revereFeatureFlagStatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getFeatureFlagStateRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiRevereTimerTaskCommandPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskCommandPost(requestParameters, options) {
            return localVarFp.revereTimerTaskCommandPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.timerTaskCommandRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiRevereTimerTaskNamesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskNamesPost(requestParameters, options) {
            return localVarFp.revereTimerTaskNamesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiRevereTimerTaskStatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revereTimerTaskStatePost(requestParameters, options) {
            return localVarFp.revereTimerTaskStatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getTimerTaskStateRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Receive webhook events from SendBlue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendblueWebhookWebhookPost(options) {
            return localVarFp.sendblueWebhookWebhookPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get an access token from a Google OAuth refresh token in the cookie
         * @param {DefaultApiSessionRefreshAccessTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionRefreshAccessTokenPost(requestParameters, options) {
            return localVarFp.sessionRefreshAccessTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set a Google OAuth refresh token used in internal apps to a cookie
         * @param {DefaultApiSessionSetRefreshTokenPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionSetRefreshTokenPost(requestParameters, options) {
            return localVarFp.sessionSetRefreshTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.setRefreshTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Receive webhook events from Twilio shortcode.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shortcodeWebhookWebhookPost(options) {
            return localVarFp.shortcodeWebhookWebhookPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get deduped suggestions for user (internal endpoint).
         * @param {DefaultApiSuggestionGetDedupedSuggestionsInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetDedupedSuggestionsInternalPost(requestParameters, options) {
            return localVarFp.suggestionGetDedupedSuggestionsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDedupedSuggestionsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get reviewable suggestions with pagination.
         * @param {DefaultApiSuggestionGetInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetInternalPost(requestParameters, options) {
            return localVarFp.suggestionGetInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getSuggestionInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get pending suggestions.
         * @param {DefaultApiSuggestionGetPendingPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetPendingPost(requestParameters, options) {
            return localVarFp.suggestionGetPendingPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getPendingDzlSuggestionsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a single suggestion by ID.
         * @param {DefaultApiSuggestionGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetPost(requestParameters, options) {
            return localVarFp.suggestionGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getSuggestionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get global quality feedback statistics.
         * @param {DefaultApiSuggestionGetQualityFeedbackStatsInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetQualityFeedbackStatsInternalPost(requestParameters, options) {
            return localVarFp.suggestionGetQualityFeedbackStatsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getQualityFeedbackStatsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get reviewable suggestions with pagination.
         * @param {DefaultApiSuggestionGetReviewableInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetReviewableInternalPost(requestParameters, options) {
            return localVarFp.suggestionGetReviewableInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getReviewableSuggestionsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get suggestions with pagination and optional uniform per-type limit.
         * @param {DefaultApiSuggestionGetSuggestionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionGetSuggestionsPost(requestParameters, options) {
            return localVarFp.suggestionGetSuggestionsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getSuggestionsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Materialize a quick suggestion by persisting photo and suggestion to storage.
         * @param {DefaultApiSuggestionQuickSuggestionMaterializePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionQuickSuggestionMaterializePost(requestParameters, options) {
            return localVarFp.suggestionQuickSuggestionMaterializePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.file, requestParameters.localAssetId, requestParameters.suggestionData, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a quick suggestion from an image.
         * @param {DefaultApiSuggestionQuickSuggestionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionQuickSuggestionPost(requestParameters, options) {
            return localVarFp.suggestionQuickSuggestionPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.file, requestParameters.xReqID, requestParameters.xRequestID, requestParameters.localAssetId, requestParameters.model, requestParameters.photoTs, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send transcription email.
         * @param {DefaultApiSuggestionSendEmailPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionSendEmailPost(requestParameters, options) {
            return localVarFp.suggestionSendEmailPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendDzlTranscriptionEmailRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Start a conversation from a suggestion.
         * @param {DefaultApiSuggestionStartConversationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionStartConversationPost(requestParameters, options) {
            return localVarFp.suggestionStartConversationPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.startConversationFromSuggestionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update suggestions status.
         * @param {DefaultApiSuggestionUpdateInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateInternalPost(requestParameters, options) {
            return localVarFp.suggestionUpdateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update suggestion quality feedback.
         * @param {DefaultApiSuggestionUpdateQualityFeedbackPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateQualityFeedbackPost(requestParameters, options) {
            return localVarFp.suggestionUpdateQualityFeedbackPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionQualityFeedbackRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update suggestions status.
         * @param {DefaultApiSuggestionUpdateStatusInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateStatusInternalPost(requestParameters, options) {
            return localVarFp.suggestionUpdateStatusInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionsStatusInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update suggestions status.
         * @param {DefaultApiSuggestionUpdateStatusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestionUpdateStatusPost(requestParameters, options) {
            return localVarFp.suggestionUpdateStatusPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionsStatusRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a specific trace by ID.
         * @param {DefaultApiTraceGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceGetPost(requestParameters, options) {
            return localVarFp.traceGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getTraceRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all traces for a conversation.
         * @param {DefaultApiTraceListPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        traceListPost(requestParameters, options) {
            return localVarFp.traceListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listTracesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiUserGetInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetInternalPost(requestParameters, options) {
            return localVarFp.userGetInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDzlUserInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {DefaultApiUserGetPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGetPost(requestParameters, options) {
            return localVarFp.userGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set or clear a user\'s developer tier (internal admin).
         * @param {DefaultApiUserSetDeveloperTierInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSetDeveloperTierInternalPost(requestParameters, options) {
            return localVarFp.userSetDeveloperTierInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.setDeveloperTierInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user details.
         * @param {DefaultApiUserUpdateInternalPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdateInternalPost(requestParameters, options) {
            return localVarFp.userUpdateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlUserInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update user details.
         * @param {DefaultApiUserUpdatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userUpdatePost(requestParameters, options) {
            return localVarFp.userUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlUserRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create an Apple Wallet pass from barcode data.
         * @param {DefaultApiWalletCreatePassPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        walletCreatePassPost(requestParameters, options) {
            return localVarFp.walletCreatePassPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createPassRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wellknownOauthAuthorizationServerGet(options) {
            return localVarFp.wellknownOauthAuthorizationServerGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @summary Refetch access token using refresh token in the cookie.
     * @param {DefaultApiAuthAccessTokenCookiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authAccessTokenCookiesPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authAccessTokenCookiesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.accessTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Refetch access token using refresh token in the header.
     * @param {DefaultApiAuthAccessTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authAccessTokenPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authAccessTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.accessTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete refresh token cookie.
     * @param {DefaultApiAuthDeleteRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authDeleteRefreshTokenPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authDeleteRefreshTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all users for internal use.
     * @param {DefaultApiAuthGetAllUsersInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authGetAllUsersInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authGetAllUsersInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllUsersInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Opt out of service.
     * @param {DefaultApiAuthOptOutPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authOptOutPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authOptOutPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send verification code to user.
     * @param {DefaultApiAuthSendVerificationCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSendVerificationCodePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authSendVerificationCodePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendVerificationCodeRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sign in with verified code.
     * @param {DefaultApiAuthSignInPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authSignInPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authSignInPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.signInRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user device token.
     * @param {DefaultApiAuthUpdateDeviceTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authUpdateDeviceTokenPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authUpdateDeviceTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDeviceTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Verify code.
     * @param {DefaultApiAuthVerifyCodePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authVerifyCodePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).authVerifyCodePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.verifyCodeRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sync calendars and events.
     * @param {DefaultApiCalendarSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calendarSyncPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).calendarSyncPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.calendarSyncRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br/>Returns Server-Sent Events (text/event-stream). Each event contains a JSON object<br/>with one of these types: ThoughtMessage, StreamingChatDelta, StreamingChatComplete, or StreamingChatTiming.<br/><br/>Event format:<br/>- ThoughtMessage: {\"type\": \"thought\", \"message\": \"...\", \"tool_name\": \"...\"}<br/>- StreamingChatDelta: {\"type\": \"delta\", \"message\": \"...\"}<br/>- StreamingChatComplete: {\"type\": \"complete\", \"message\": {...}}<br/>- StreamingChatTiming: {\"type\": \"timing\", \"total_ms\": ..., \"breakdown\": {...}}
     * @summary Process a streaming chat completion request.
     * @param {DefaultApiChatStreamPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    chatStreamPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).chatStreamPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.chatRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabDuplicatesConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabDuplicatesConfirmPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabDuplicatesConfirmPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabConfirmDuplicatesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabDuplicatesListSetsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabDuplicatesListSetsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabDuplicatesListSetsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListDuplicateSetsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabDuplicatesMarkNotDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabDuplicatesMarkNotDuplicatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabDuplicatesMarkNotDuplicatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabMarkNotDuplicateRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabExportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabExportPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabExportPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabExportRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabGroupsCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabGroupsCreatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabGroupsCreatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabCreateGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabGroupsDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabGroupsDeletePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabGroupsDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabDeleteGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabGroupsListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabGroupsListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabGroupsListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListGroupsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabGroupsUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabGroupsUpdatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabGroupsUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabUpdateGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabMembersAssignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabMembersAssignPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabMembersAssignPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabAssignMembersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabMembersUnassignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabMembersUnassignPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabMembersUnassignPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabUnassignMembersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabPhotosListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabPhotosListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabPhotosListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabShareworthyConfirmPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabShareworthyConfirmPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabShareworthyConfirmPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabConfirmShareworthyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiClusteringLabShareworthyListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clusteringLabShareworthyListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).clusteringLabShareworthyListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clusteringLabListShareworthyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Bulk delete conversations.
     * @param {DefaultApiConversationBulkDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationBulkDeletePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationBulkDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.bulkDeleteDzlConversationsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get conversation for any user.
     * @param {DefaultApiConversationCreateInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationCreateInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationCreateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createDzlConversationInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get conversation for any user.
     * @param {DefaultApiConversationDeleteInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationDeleteInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationDeleteInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.deleteDzlConversationInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete conversation.
     * @param {DefaultApiConversationDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationDeletePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.deleteDzlConversationRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all conversations for user (internal endpoint).
     * @param {DefaultApiConversationGetConversationsInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationGetConversationsInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationGetConversationsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getConversationsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get conversation for any user.
     * @param {DefaultApiConversationGetInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationGetInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationGetInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getConversationInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get single conversation.
     * @param {DefaultApiConversationGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDzlConversationRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Increment copy count for a message.
     * @param {DefaultApiConversationIncrementCopyCountPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationIncrementCopyCountPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationIncrementCopyCountPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.incrementMessageCopyCountRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all conversations.
     * @param {DefaultApiConversationListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllDzlConversationsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send message as Dazzle.
     * @param {DefaultApiConversationSendAsDazzlePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    conversationSendAsDazzlePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).conversationSendAsDazzlePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendDazzleMessageRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a new dataset entry.
     * @param {DefaultApiEvalDatasetCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalDatasetCreatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalDatasetCreatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlCreateDatasetEntryRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Soft-delete a dataset entry.
     * @param {DefaultApiEvalDatasetDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalDatasetDeletePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalDatasetDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlDeleteDatasetEntryRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List dataset entries for a suite.
     * @param {DefaultApiEvalDatasetListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalDatasetListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalDatasetListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlListDatasetEntriesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List candidate photos for seeding the golden dataset.
     * @param {DefaultApiEvalDatasetSeedCandidatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalDatasetSeedCandidatesPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalDatasetSeedCandidatesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlListSeedCandidatesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a dataset entry.
     * @param {DefaultApiEvalDatasetUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalDatasetUpdatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalDatasetUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlUpdateDatasetEntryRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get eval run status.
     * @param {DefaultApiEvalRunGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalRunGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalRunGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlGetEvalRunRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List recent eval runs.
     * @param {DefaultApiEvalRunListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalRunListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalRunListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlListEvalRunsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get results for an eval run.
     * @param {DefaultApiEvalRunResultsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalRunResultsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalRunResultsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlGetEvalRunResultsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start a new eval run.
     * @param {DefaultApiEvalRunStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    evalRunStartPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).evalRunStartPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlStartEvalRunRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get important people.
     * @param {DefaultApiFaceGetImportantPeoplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    faceGetImportantPeoplePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).faceGetImportantPeoplePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all photos for a specific person.
     * @param {DefaultApiFaceGetPersonPhotosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    faceGetPersonPhotosPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).faceGetPersonPhotosPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getPersonPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Submit feedback for an LLM-produced item.
     * @param {DefaultApiFeedbackSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    feedbackSubmitPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).feedbackSubmitPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.submitFeedbackRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Health check endpoint for deployment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthCheckHealthGet(options) {
        return DefaultApiFp(this.configuration).healthCheckHealthGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get profile insights for the current user.
     * @param {DefaultApiInsightGetInsightsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insightGetInsightsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).insightGetInsightsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getInsightsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark insights as dismissed for the current user.
     * @param {DefaultApiInsightMarkInsightsDismissedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    insightMarkInsightsDismissedPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).insightMarkInsightsDismissedPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.markInsightsDismissedRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiMcpAgentListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpAgentListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpAgentListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listMcpAgentsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiMcpAgentRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpAgentRevokePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpAgentRevokePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.revokeMcpAgentRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary JSON-RPC transport for /apps/<client_id>.
     * @param {DefaultApiMcpAppsStringClientIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpAppsStringClientIdPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpAppsStringClientIdPost(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary RFC 7591 dynamic client registration. Returns the pre-seeded client_id.
     * @param {DefaultApiMcpAppsStringClientIdRegisterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpAppsStringClientIdRegisterPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpAppsStringClientIdRegisterPost(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary RFC 6749 token endpoint scoped to <client_id>; mints with per-client iss.
     * @param {DefaultApiMcpAppsStringClientIdTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpAppsStringClientIdTokenPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpAppsStringClientIdTokenPost(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Handle MCP JSON-RPC requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpPost(options) {
        return DefaultApiFp(this.configuration).mcpPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiMcpTraceGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpTraceGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpTraceGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getMcpTraceRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Page through MCP traces for a user, newest first.
     * @param {DefaultApiMcpTraceListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpTraceListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpTraceListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listMcpTracesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary RFC 8414 Authorization Server Metadata for /apps/<client_id>.
     * @param {DefaultApiMcpWellknownOauthAuthorizationServerAppsStringClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpWellknownOauthAuthorizationServerAppsStringClientIdGet(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpWellknownOauthAuthorizationServerAppsStringClientIdGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary RFC 9728 Protected Resource Metadata for /apps/<client_id>.
     * @param {DefaultApiMcpWellknownOauthProtectedResourceAppsStringClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpWellknownOauthProtectedResourceAppsStringClientIdGet(requestParameters, options) {
        return DefaultApiFp(this.configuration).mcpWellknownOauthProtectedResourceAppsStringClientIdGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary RFC 9728 Protected Resource Metadata for the MCP endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpWellknownOauthProtectedResourceGet(options) {
        return DefaultApiFp(this.configuration).mcpWellknownOauthProtectedResourceGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br/>OpenAI supplies the token at directory-submission time; it is stored per environment in<br/>config (`OpenAiAppsChallenge`). Returns 404 until configured, so the route is inert<br/>before submission and never leaks a placeholder.
     * @summary Serve the OpenAI ChatGPT Apps domain-verification token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mcpWellknownOpenaiAppsChallengeGet(options) {
        return DefaultApiFp(this.configuration).mcpWellknownOpenaiAppsChallengeGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Detailed monitoring endpoint.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    monitorCheckMonitorGet(options) {
        return DefaultApiFp(this.configuration).monitorCheckMonitorGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2AuthorizeGet(options) {
        return DefaultApiFp(this.configuration).oauth2AuthorizeGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2DeviceAuthorizationPost(options) {
        return DefaultApiFp(this.configuration).oauth2DeviceAuthorizationPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiOauth2InternalAuthorizePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2InternalAuthorizePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).oauth2InternalAuthorizePost(requestParameters.authorizeInternalRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiOauth2InternalClientsStringClientIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2InternalClientsStringClientIdGet(requestParameters, options) {
        return DefaultApiFp(this.configuration).oauth2InternalClientsStringClientIdGet(requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiOauth2InternalDeviceApprovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2InternalDeviceApprovePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).oauth2InternalDeviceApprovePost(requestParameters.deviceApproveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiOauth2InternalDeviceDenyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2InternalDeviceDenyPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).oauth2InternalDeviceDenyPost(requestParameters.deviceApproveRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiOauth2InternalDeviceVerifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2InternalDeviceVerifyPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).oauth2InternalDeviceVerifyPost(requestParameters.deviceVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2JwksGet(options) {
        return DefaultApiFp(this.configuration).oauth2JwksGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2RevokePost(options) {
        return DefaultApiFp(this.configuration).oauth2RevokePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    oauth2TokenPost(options) {
        return DefaultApiFp(this.configuration).oauth2TokenPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get onboarding events with computed latencies for a user.
     * @param {DefaultApiOnboardingGetEventsInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    onboardingGetEventsInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).onboardingGetEventsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getOnboardingEventsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Record an onboarding event for the current user.
     * @param {DefaultApiOnboardingRecordEventPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    onboardingRecordEventPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).onboardingRecordEventPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.recordOnboardingEventRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Assign order to fulfiller.
     * @param {DefaultApiOrderAssignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderAssignPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderAssignPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlAssignOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Mark order as complete.
     * @param {DefaultApiOrderCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderCompletePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderCompletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlOrderCompleteRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an order from a suggestion.
     * @param {DefaultApiOrderCreateFromSuggestionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderCreateFromSuggestionPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderCreateFromSuggestionPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createDzlOrderFromSuggestionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create order.
     * @param {DefaultApiOrderCreateInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderCreateInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderCreateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlCreateOrderInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete order.
     * @param {DefaultApiOrderDeleteInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderDeleteInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderDeleteInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlDeleteOrderInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get single order.
     * @param {DefaultApiOrderGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDzlOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all orders.
     * @param {DefaultApiOrderListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllDzlOrdersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Process order payment.
     * @param {DefaultApiOrderPaymentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderPaymentPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderPaymentPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlOrderPaymentRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Place a new order.
     * @param {DefaultApiOrderPlacePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderPlacePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderPlacePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.placeDzlOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send payment link to user via iMessage.
     * @param {DefaultApiOrderSendPaymentLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderSendPaymentLinkPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderSendPaymentLinkPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendPaymentLinkRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Clear Stripe information for a user.
     * @param {DefaultApiOrderStripeClearPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderStripeClearPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderStripeClearPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.clearDzlStripeRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirm Stripe setup intent.
     * @param {DefaultApiOrderStripeConfirmSetupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderStripeConfirmSetupPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderStripeConfirmSetupPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.confirmDzlStripeSetupIntentRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Stripe setup intent.
     * @param {DefaultApiOrderStripeSetupIntentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderStripeSetupIntentPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderStripeSetupIntentPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update order.
     * @param {DefaultApiOrderUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    orderUpdatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).orderUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlUpdateOrderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete photos by local asset IDs.
     * @param {DefaultApiPhotoDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoDeletePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoDeletePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.deletePhotoRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upload photo features/metadata for multiple photos.
     * @param {DefaultApiPhotoFeaturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoFeaturesPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoFeaturesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.uploadPhotoFeaturesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get photo URLs for asset IDs.
     * @param {DefaultApiPhotoGetUrlsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGetUrlsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGetUrlsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getPhotoUrlsForAssetIdsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Accept a photo group with optional custom tags.
     * @param {DefaultApiPhotoGroupAcceptPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupAcceptPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupAcceptPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.acceptPhotoGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a conversation thread from a photo group.
     * @param {DefaultApiPhotoGroupCreateThreadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupCreateThreadPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupCreateThreadPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createThreadFromGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Dismiss a photo group.
     * @param {DefaultApiPhotoGroupDismissPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupDismissPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupDismissPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dismissPhotoGroupRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start profile idea generation.
     * @param {DefaultApiPhotoGroupGenerateProfileStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupGenerateProfileStartPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupGenerateProfileStartPost(requestParameters.generateProfileStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get photo groups and ideas for a user, with optional S3 URLs.
     * @param {DefaultApiPhotoGroupGetUserDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupGetUserDataPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupGetUserDataPost(requestParameters.getUserPhotoGroupsAndIdeasRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List photo groups for the authenticated user.
     * @param {DefaultApiPhotoGroupListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listPhotoGroupsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Regenerate photo groups and/or IDEAS for a specific user.
     * @param {DefaultApiPhotoGroupRegenerateIdeasPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupRegenerateIdeasPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupRegenerateIdeasPost(requestParameters.regenerateIdeasRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start regeneration by marking pending for workers.
     * @param {DefaultApiPhotoGroupRegenerateStartPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupRegenerateStartPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupRegenerateStartPost(requestParameters.regenerateStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update tags for an existing photo group.
     * @param {DefaultApiPhotoGroupUpdateTagsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoGroupUpdateTagsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoGroupUpdateTagsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updatePhotoGroupTagsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * <br/>Expects multipart/form-data with:<br/>- local_asset_id: The local asset ID<br/>- file: The photo file
     * @summary Upload a photo.
     * @param {DefaultApiPhotoUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    photoUploadPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).photoUploadPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.file, requestParameters.localAssetId, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPlatformKeyCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformKeyCreatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).platformKeyCreatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createPlatformApiKeyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPlatformKeyListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformKeyListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).platformKeyListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPlatformKeyRevokePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformKeyRevokePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).platformKeyRevokePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.revokePlatformApiKeyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiPlatformKeyUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    platformKeyUpdatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).platformKeyUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updatePlatformApiKeyRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabChatProcessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabChatProcessPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabChatProcessPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabProcessChatRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabDatasetExportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabDatasetExportPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabDatasetExportPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabExportDatasetRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabPeopleListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabPeopleListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabPeopleListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabListPeopleRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabPeoplePhotosPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabPeoplePhotosPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabPeoplePhotosPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabGetPersonPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabPhotosListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabPhotosListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabPhotosListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabListPhotosRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabPhotosSignedUrlsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabPhotosSignedUrlsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabPhotosSignedUrlsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabGetSignedUrlsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabSelectionComputePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabSelectionComputePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabSelectionComputePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabComputeSelectionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabStagePreviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabStagePreviewPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabStagePreviewPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabRunStageRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabStageResultGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabStageResultGet(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabStageResultGet(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.userLid, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabStageRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabStageRunPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabStageRunPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabRunStageRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabStageStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabStageStatusGet(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabStageStatusGet(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.userLid, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabStagesDefinitionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabStagesDefinitionPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabStagesDefinitionPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.profileLabGetStageDefinitionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiProfileLabStagesListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    profileLabStagesListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).profileLabStagesListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Fetch prompts by type.
     * @param {DefaultApiPromptFetchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    promptFetchPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).promptFetchPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlFetchPromptsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update prompt text.
     * @param {DefaultApiPromptUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    promptUpdatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).promptUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.dzlUpdatePromptRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add a new reminder.
     * @param {DefaultApiReminderAddPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reminderAddPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).reminderAddPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.addDzlReminderRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all reminders.
     * @param {DefaultApiReminderListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reminderListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).reminderListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getAllDzlRemindersRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Schedule a reminder notification.
     * @param {DefaultApiReminderScheduleNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reminderScheduleNotificationPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).reminderScheduleNotificationPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.scheduleReminderNotificationRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update reminder status.
     * @param {DefaultApiReminderUpdateStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reminderUpdateStatusPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).reminderUpdateStatusPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlReminderStatusRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiRevereFeatureFlagCommandPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revereFeatureFlagCommandPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).revereFeatureFlagCommandPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.featureFlagCommandRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiRevereFeatureFlagNamesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revereFeatureFlagNamesPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).revereFeatureFlagNamesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiRevereFeatureFlagStatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revereFeatureFlagStatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).revereFeatureFlagStatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getFeatureFlagStateRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiRevereTimerTaskCommandPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revereTimerTaskCommandPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).revereTimerTaskCommandPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.timerTaskCommandRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiRevereTimerTaskNamesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revereTimerTaskNamesPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).revereTimerTaskNamesPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiRevereTimerTaskStatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revereTimerTaskStatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).revereTimerTaskStatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getTimerTaskStateRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Receive webhook events from SendBlue.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendblueWebhookWebhookPost(options) {
        return DefaultApiFp(this.configuration).sendblueWebhookWebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get an access token from a Google OAuth refresh token in the cookie
     * @param {DefaultApiSessionRefreshAccessTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionRefreshAccessTokenPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).sessionRefreshAccessTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set a Google OAuth refresh token used in internal apps to a cookie
     * @param {DefaultApiSessionSetRefreshTokenPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sessionSetRefreshTokenPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).sessionSetRefreshTokenPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.setRefreshTokenRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Receive webhook events from Twilio shortcode.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    shortcodeWebhookWebhookPost(options) {
        return DefaultApiFp(this.configuration).shortcodeWebhookWebhookPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get deduped suggestions for user (internal endpoint).
     * @param {DefaultApiSuggestionGetDedupedSuggestionsInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetDedupedSuggestionsInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetDedupedSuggestionsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDedupedSuggestionsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get reviewable suggestions with pagination.
     * @param {DefaultApiSuggestionGetInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getSuggestionInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get pending suggestions.
     * @param {DefaultApiSuggestionGetPendingPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetPendingPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetPendingPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getPendingDzlSuggestionsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a single suggestion by ID.
     * @param {DefaultApiSuggestionGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getSuggestionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get global quality feedback statistics.
     * @param {DefaultApiSuggestionGetQualityFeedbackStatsInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetQualityFeedbackStatsInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetQualityFeedbackStatsInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getQualityFeedbackStatsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get reviewable suggestions with pagination.
     * @param {DefaultApiSuggestionGetReviewableInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetReviewableInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetReviewableInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getReviewableSuggestionsInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get suggestions with pagination and optional uniform per-type limit.
     * @param {DefaultApiSuggestionGetSuggestionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionGetSuggestionsPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionGetSuggestionsPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getSuggestionsRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Materialize a quick suggestion by persisting photo and suggestion to storage.
     * @param {DefaultApiSuggestionQuickSuggestionMaterializePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionQuickSuggestionMaterializePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionQuickSuggestionMaterializePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.file, requestParameters.localAssetId, requestParameters.suggestionData, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a quick suggestion from an image.
     * @param {DefaultApiSuggestionQuickSuggestionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionQuickSuggestionPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionQuickSuggestionPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.file, requestParameters.xReqID, requestParameters.xRequestID, requestParameters.localAssetId, requestParameters.model, requestParameters.photoTs, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send transcription email.
     * @param {DefaultApiSuggestionSendEmailPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionSendEmailPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionSendEmailPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.sendDzlTranscriptionEmailRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Start a conversation from a suggestion.
     * @param {DefaultApiSuggestionStartConversationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionStartConversationPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionStartConversationPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.startConversationFromSuggestionRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update suggestions status.
     * @param {DefaultApiSuggestionUpdateInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionUpdateInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionUpdateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update suggestion quality feedback.
     * @param {DefaultApiSuggestionUpdateQualityFeedbackPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionUpdateQualityFeedbackPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionUpdateQualityFeedbackPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionQualityFeedbackRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update suggestions status.
     * @param {DefaultApiSuggestionUpdateStatusInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionUpdateStatusInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionUpdateStatusInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionsStatusInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update suggestions status.
     * @param {DefaultApiSuggestionUpdateStatusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suggestionUpdateStatusPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).suggestionUpdateStatusPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlSuggestionsStatusRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a specific trace by ID.
     * @param {DefaultApiTraceGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    traceGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).traceGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getTraceRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all traces for a conversation.
     * @param {DefaultApiTraceListPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    traceListPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).traceListPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.listTracesRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUserGetInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userGetInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).userGetInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.getDzlUserInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {DefaultApiUserGetPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userGetPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).userGetPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.body, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set or clear a user\'s developer tier (internal admin).
     * @param {DefaultApiUserSetDeveloperTierInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSetDeveloperTierInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).userSetDeveloperTierInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.setDeveloperTierInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user details.
     * @param {DefaultApiUserUpdateInternalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUpdateInternalPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).userUpdateInternalPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlUserInternalRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update user details.
     * @param {DefaultApiUserUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUpdatePost(requestParameters, options) {
        return DefaultApiFp(this.configuration).userUpdatePost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.updateDzlUserRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create an Apple Wallet pass from barcode data.
     * @param {DefaultApiWalletCreatePassPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    walletCreatePassPost(requestParameters, options) {
        return DefaultApiFp(this.configuration).walletCreatePassPost(requestParameters.xUserAgent, requestParameters.xDeviceID, requestParameters.createPassRequest, requestParameters.xReqID, requestParameters.xRequestID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    wellknownOauthAuthorizationServerGet(options) {
        return DefaultApiFp(this.configuration).wellknownOauthAuthorizationServerGet(options).then((request) => request(this.axios, this.basePath));
    }
}
